
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cmkWO", function(module, exports) {

$parcel$export(module.exports, "MainLayout", () => $a171d54840e7d827$export$93af822566053b3e);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $xQxzY = parcelRequire("xQxzY");

var $kVysQ = parcelRequire("kVysQ");
var $6CEg5 = parcelRequire("6CEg5");

var $7Sm4c = parcelRequire("7Sm4c");

var $dIouf = parcelRequire("dIouf");

var $5vi32 = parcelRequire("5vi32");

var $c323h = parcelRequire("c323h");

var $3jwuS = parcelRequire("3jwuS");

var $ddOcd = parcelRequire("ddOcd");
const $a171d54840e7d827$export$93af822566053b3e = /*#__PURE__*/ (0, $gwFzn.memo)(({ spaceKey: spaceKey, isEdit: isEdit, enableNavigation: enableNavigation, isViewPage: isViewPage, ...otherProps })=>{
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { data: data, error: unhandledError } = (0, $xQxzY.useQuery)((0, $d2LG0.default)`query MainLayoutQuery($spaceKey:String!){space(key:$spaceKey){id lookAndFeel{content{screen{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode}}}}}`, {
        variables: {
            // When spaceKey is undefined/falsy the query is skipped, so defaulting it to
            // an empty string doesn't change the logic but merely keeps TypeScript happy.
            spaceKey: spaceKey || ''
        },
        skip: !spaceKey || isEdit || isLivePage
    });
    let error = unhandledError;
    if ((0, $dIouf.isNotFoundError)(error) || (0, $dIouf.isUnauthorizedError)(error)) {
        // The MainLayoutQuery only loads the space styling configuration, and neither error nor
        // missing configuration don't break the user experience. Unauthorized or NotFound error
        // (anonymous user, restricted or missing space/page) are handled by children components
        // of MainLayout and are part of the normal user flow, hence these can be safely muted.
        (0, $7Sm4c.markErrorAsHandled)(error);
        error = undefined;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6CEg5.PerformanceStart), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_mainLayout)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ddOcd.MainLayoutComponent), {
        ...otherProps,
        enableNavigation: isEmbeddedConfluence ? false : enableNavigation,
        screen: data?.space?.lookAndFeel?.content?.screen ?? undefined,
        isViewPage: isViewPage,
        isEdit: isEdit
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $c323h.AutomatedMeetingNotesSpotlightWrapper), null));
});

});
parcelRegister("kVysQ", function(module, exports) {

$parcel$export(module.exports, "PERFORMANCE_SUBJECT_linkToPage", () => $35b50a968705ed01$export$c4d483efe8eba686);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_mainLayout", () => $35b50a968705ed01$export$1de09ba64e7728f2);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_manageWatcherDialog", () => $35b50a968705ed01$export$586856ecee8f0723);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_navigation", () => $35b50a968705ed01$export$51f018e0f9f84a74);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_navigationFMP", () => $35b50a968705ed01$export$94afb8303c61d07d);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_sideNavigationFMP", () => $35b50a968705ed01$export$fe596581250cd9fc);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_navigationView", () => $35b50a968705ed01$export$88c949ed1e388f68);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_recentDropdown", () => $35b50a968705ed01$export$1a3cc5086fadf289);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_resolvedInlineCommentsDialog", () => $35b50a968705ed01$export$b35db70015797a33);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_copyPageTree", () => $35b50a968705ed01$export$5c78998b70cdff69);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_spaceDirectory", () => $35b50a968705ed01$export$1167e4f56227df4c);
const $35b50a968705ed01$export$9960fc620d4470dd = 'comments';
const $35b50a968705ed01$export$c4d483efe8eba686 = 'link-to-page';
const $35b50a968705ed01$export$1de09ba64e7728f2 = 'main-layout';
const $35b50a968705ed01$export$586856ecee8f0723 = 'manage-watcher-dialog';
const $35b50a968705ed01$export$51f018e0f9f84a74 = 'Navigation';
const $35b50a968705ed01$export$94afb8303c61d07d = 'navigation-fmp';
const $35b50a968705ed01$export$fe596581250cd9fc = 'side-navigation-fmp';
const $35b50a968705ed01$export$88c949ed1e388f68 = 'NavigationView';
const $35b50a968705ed01$export$1a3cc5086fadf289 = 'recent-dropdown';
const $35b50a968705ed01$export$b35db70015797a33 = 'resolved-inline-comments-dialog';
const $35b50a968705ed01$export$5c78998b70cdff69 = 'copy-page-tree';
const $35b50a968705ed01$export$1167e4f56227df4c = 'space-directory';

});

parcelRegister("c323h", function(module, exports) {

$parcel$export(module.exports, "AutomatedMeetingNotesSpotlightWrapper", () => $9eab5d375ba1bffd$export$edf3ca4196271bf8);
/* AutomatedMeetingNotesSpotlightComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $lAFHW = parcelRequire("lAFHW");

var $lnqHu = parcelRequire("lnqHu");

var $91xA1 = parcelRequire("91xA1");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $1GzhS = parcelRequire("1GzhS");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $1qfLF = parcelRequire("1qfLF");

var $2Nwuj = parcelRequire("2Nwuj");

var $inPa6 = parcelRequire("inPa6");

var $5U2Bi = parcelRequire("5U2Bi");

var $dlxup = parcelRequire("dlxup");
const $9eab5d375ba1bffd$var$closeIconStyle = (0, $ecnYn.xcss)({
    position: 'absolute',
    top: "var(--ds-space-200, 16px)",
    right: "var(--ds-space-200, 16px)",
    background: "var(--ds-surface, #FFFFFF)",
    borderRadius: "var(--ds-space-200, 16px)"
});
const $9eab5d375ba1bffd$var$closeIconBackgroundStyle = (0, $ecnYn.xcss)({
    cursor: 'pointer',
    alignItems: 'center',
    top: "var(--ds-space-300, 24px)"
});
const $9eab5d375ba1bffd$var$contentStyle = (0, $ecnYn.xcss)({
    paddingBottom: 'space.300'
});
const $9eab5d375ba1bffd$var$spotlightCardWrapperStyle = null;
const $9eab5d375ba1bffd$var$i18n = (0, $2nPZH.defineMessages)({
    spotlightTitle: {
        id: "automated-meeting-notes.spotlight.title",
        defaultMessage: "Never take another meeting note"
    },
    spotlightDescription: {
        id: "automated-meeting-notes.spotlight.description",
        defaultMessage: "Track action items, take notes, and send a meeting recap with Loom AI for meetings."
    },
    startRecording: {
        id: "automated-meeting-notes.spotlight.startRecording",
        defaultMessage: "Start recording"
    },
    closeButtonLabel: {
        id: "automated-meeting-notes.spotlight.closeButtonLabel",
        defaultMessage: "Close"
    }
});
const $9eab5d375ba1bffd$var$loomHref = 'https://www.loom.com/meetings/settings?ignore_redirect=1';
const $9eab5d375ba1bffd$export$b30968b1b90f389b = ({ onClose: onClose, pageSource: pageSource })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onStartRecording = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: pageSource,
                action: 'clicked',
                actionSubject: 'meetingNotesSpotlightCTA'
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        pageSource
    ]);
    const onSpotlightDismissed = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: pageSource,
                action: 'dismissed',
                actionSubject: 'meetingNotesSpotlightCTA'
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        pageSource
    ]);
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            "_kqsw1n9t _1ltv1ejb _94n51ejb _1pby1rya _1g96u2gc _1vxe1ejb _fkwn1bhr _1pks1cd0 _tml11fxt"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $91xA1.default), {
        width: 480,
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($5U2Bi))),
            alt: "",
            width: "480px"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $9eab5d375ba1bffd$var$closeIconStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                xcss: $9eab5d375ba1bffd$var$closeIconBackgroundStyle
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lnqHu))), iconProps)),
        shape: "circle",
        appearance: "subtle",
        label: formatMessage($9eab5d375ba1bffd$var$i18n.closeButtonLabel),
        onClick: ()=>{
            onClose();
            onSpotlightDismissed();
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        gap: "space.200",
        xcss: $9eab5d375ba1bffd$var$contentStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lAFHW.LoomIcon), {
        appearance: "brand"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        color: "color.text",
        size: "large"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $9eab5d375ba1bffd$var$i18n.spotlightTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $9eab5d375ba1bffd$var$i18n.spotlightDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
        href: $9eab5d375ba1bffd$var$loomHref,
        target: "_blank",
        onClick: ()=>onStartRecording()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $9eab5d375ba1bffd$var$i18n.startRecording))))));
};
const $9eab5d375ba1bffd$export$edf3ca4196271bf8 = ()=>{
    const [{ isHidden: isHidden, pageSourceType: pageSourceType }, { onCloseSpotlight: onCloseSpotlight }] = (0, $dlxup.useAutomatedMeetingNotesSpotlight)();
    return isHidden ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($9eab5d375ba1bffd$export$b30968b1b90f389b, {
        onClose: onCloseSpotlight,
        pageSource: pageSourceType
    });
};

});
parcelRegister("5U2Bi", function(module, exports) {
module.exports = new URL("Thumbnail.d9124b79.svg", import.meta.url).toString();

});

parcelRegister("dlxup", function(module, exports) {

$parcel$export(module.exports, "AutomatedMeetingNotesSpotlightPageSource", () => $1b3a4b2928c8d164$export$f79d013bbb911089);
$parcel$export(module.exports, "useAutomatedMeetingNotesSpotlight", () => $1b3a4b2928c8d164$export$8259bebea3663b57);
$parcel$export(module.exports, "useAutomatedMeetingNotesSpotlightActions", () => $1b3a4b2928c8d164$export$89ae432803231630);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");

var $gKr8t = parcelRequire("gKr8t");

var $ge2sX = parcelRequire("ge2sX");

var $04e9M = parcelRequire("04e9M");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $6mYmv = parcelRequire("6mYmv");
var $1b3a4b2928c8d164$export$f79d013bbb911089 = /*#__PURE__*/ function(AutomatedMeetingNotesSpotlightPageSource) {
    AutomatedMeetingNotesSpotlightPageSource["MEETING_NOTES_TEMPLATE"] = "MEETING_NOTES_TEMPLATE";
    AutomatedMeetingNotesSpotlightPageSource["TEAM_CALENDAR"] = "TEAM_CALENDAR";
    AutomatedMeetingNotesSpotlightPageSource["PERSONAL_CALENDAR"] = "PERSONAL_CALENDAR";
    AutomatedMeetingNotesSpotlightPageSource["AMN_VIEW_PAGE"] = "AMN_VIEW_PAGE";
    return AutomatedMeetingNotesSpotlightPageSource;
}({});
const $1b3a4b2928c8d164$export$734f885fe7403cc8 = {
    onOpenSpotlightIfNeeded: (pageSourceType)=>async ({ setState: setState, getState: getState })=>{
            const numberTimesShown = Number((0, $e9zUf.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).AMN_SPOTLIGHT_KEY) || 0);
            if (numberTimesShown >= 2) return;
            // eslint-disable-next-line prefer-const
            let { meetingNotesAvailable: meetingNotesAvailable, meetingNotesEnabled: meetingNotesEnabled, isHidden: isHidden } = getState();
            if (meetingNotesAvailable === undefined || meetingNotesEnabled === undefined) {
                const meetingSettings = await $1b3a4b2928c8d164$var$getMeetingNotesSettings();
                meetingNotesAvailable = meetingSettings.meetingNotesAvailable;
                meetingNotesEnabled = meetingSettings.meetingNotesEnabled;
            }
            const shouldShowSpotlight = meetingNotesAvailable && !meetingNotesEnabled && isHidden;
            if (shouldShowSpotlight) {
                setState({
                    isHidden: false,
                    pageSourceType: pageSourceType
                });
                (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).AMN_SPOTLIGHT_KEY, numberTimesShown + 1);
                (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                    client.sendScreenEvent({
                        name: 'meetingNotesSpotlight',
                        attributes: {
                            nudgeSource: pageSourceType
                        }
                    });
                });
            }
        },
    onCloseSpotlight: ()=>async ({ setState: setState })=>{
            setState({
                isHidden: true
            });
        }
};
const $1b3a4b2928c8d164$var$Store = (0, $4ZoIm.createStore)({
    initialState: {
        isHidden: true,
        pageSourceType: null
    },
    actions: $1b3a4b2928c8d164$export$734f885fe7403cc8,
    name: 'automatedMeetingNotesSpotlightState'
});
const $1b3a4b2928c8d164$export$8259bebea3663b57 = (0, $iFWZA.createHook)($1b3a4b2928c8d164$var$Store);
const $1b3a4b2928c8d164$export$89ae432803231630 = (0, $iFWZA.createActionsHook)($1b3a4b2928c8d164$var$Store);
const $1b3a4b2928c8d164$var$getMeetingNotesSettings = async ()=>{
    const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
    const { data: data, errors: errors } = await (0, $gKr8t.getAGGClient)().query({
        query: (0, $6mYmv.MeetingNotesSettingsQuery),
        variables: {
            siteId: cloudId
        }
    });
    if (errors) throw errors;
    return data.loom_settings;
};

});
parcelRegister("6mYmv", function(module, exports) {

$parcel$export(module.exports, "MeetingNotesSettingsQuery", () => $a5045d316cf57d7d$export$8dd57231676e4d77);

var $d2LG0 = parcelRequire("d2LG0");
const $a5045d316cf57d7d$export$8dd57231676e4d77 = (0, $d2LG0.default)`query MeetingNotesSettingsQuery($siteId:ID!){loom_settings(siteId:$siteId){meetingNotesAvailable meetingNotesEnabled}}`;

});



parcelRegister("ddOcd", function(module, exports) {

$parcel$export(module.exports, "MainLayoutComponent", () => $4e0d0b830c02a893$export$375787c0d3c11135);
/* MainLayoutComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $ipPpS = parcelRequire("ipPpS");

var $gz8ZY = parcelRequire("gz8ZY");

var $3PXtn = parcelRequire("3PXtn");

var $dIouf = parcelRequire("dIouf");

var $eSLr0 = parcelRequire("eSLr0");

var $hDG7z = parcelRequire("hDG7z");

var $hsPwY = parcelRequire("hsPwY");
var $9Z1sw = parcelRequire("9Z1sw");

var $fTjAG = parcelRequire("fTjAG");

var $2DRHd = parcelRequire("2DRHd");

var $kVysQ = parcelRequire("kVysQ");
var $4NX9d = parcelRequire("4NX9d");

var $jln20 = parcelRequire("jln20");

var $3jwuS = parcelRequire("3jwuS");

var $9wGTI = parcelRequire("9wGTI");

var $e4o8D = parcelRequire("e4o8D");

var $8zMP3 = parcelRequire("8zMP3");

var $eYvuU = parcelRequire("eYvuU");

var $1EzU0 = parcelRequire("1EzU0");

var $1kZY5 = parcelRequire("1kZY5");

var $gU0tm = parcelRequire("gU0tm");
const $4e0d0b830c02a893$var$webPanelWrapperStyles = {
    showPanel: "_1e0c1ule",
    hidePanel: "_1e0cglyw"
};
const $4e0d0b830c02a893$var$contentBodyWrapperStyles = null;
const $4e0d0b830c02a893$var$fixedWebPanelSpacerStyles = null;
const $4e0d0b830c02a893$var$fixedForgeBannerSpacerStyles = null;
const $4e0d0b830c02a893$var$mainContentContainerStyles = {
    default: "_v5641fl4 _2lx2vrvc _1n261g80 _1bsb15jn _18u0v77o _1s6jaq80",
    enableRightSidebar: "_1bsbsul6",
    nav4Enabled: "_1bsb1osq _18u0ze3t",
    addMinWidth: "_1ul9cv93"
};
const $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles = {
    default: "_1e0cglyw _1pby1ial _1bsb1osq _kqsw1n9t _bfhkvuon _1ltv1d4h _p12f18ua",
    showPanel: "_1e0c1ule",
    isFullWidth: "_1ltvidpf _p12fglyw"
};
const $4e0d0b830c02a893$var$ContentBodyCompiled = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11q7vuon _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _s7n4jp4b _1tke1wug _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles
const $4e0d0b830c02a893$var$ContentBodyWithContainerTypeCompiled = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11q7vuon _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _s7n4jp4b _1tke1wug _1bsb1osq _7cca15wb _1f381gzp",
            __cmplp.className
        ])
    });
});
const $4e0d0b830c02a893$export$375787c0d3c11135 = ({ navView: navView, enableNavigation: enableNavigation = true, disableMinWidth: disableMinWidth, screen: screen, editorPreloader: editorPreloader, isViewPage: isViewPage = false, isEdit: isEdit, children: children })=>{
    const [preloader, setPreloader] = (0, $gwFzn.useState)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const { shouldShowATLGeneralWebPanel: shouldShowATLGeneralWebPanel, isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed, fixedATLGeneralWebPanelRef: fixedATLGeneralWebPanelRef, isFullWidth: isFullWidth, shouldHidePanels: shouldHidePanels } = (0, $hsPwY.useATLGeneralWebPanelObserver)(isViewPage);
    const { isForgePageBannerFixed: isForgePageBannerFixed, fixedForgePageBannerRef: fixedForgePageBannerRef, isForgePageBannerFullWidth: isForgePageBannerFullWidth, shouldHideForgePageBanner: shouldHideForgePageBanner } = (0, $fTjAG.useForgePageBannerObserver)(isViewPage, isNav4Enabled, isEdit);
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const [enableRightSidebarCSS, setEnableRightSidebarCSS] = (0, $gwFzn.useState)(false);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const enableBreakoutScript = renderServerPlaceholder && (0, $9wGTI.fg)('confluence_preset_atl_general_height');
    const topElementStyle = {};
    if (screen) for(const key in screen){
        if (screen.hasOwnProperty(key)) {
            if (key.startsWith('background')) topElementStyle[key] = screen[key];
        }
    }
    (0, $gwFzn.useEffect)(()=>{
        if (rightSidebarContext.getCurrent()) setEnableRightSidebarCSS(true);
    }, [
        rightSidebarContext
    ]);
    (0, $gwFzn.useEffect)(()=>{
        setEditorPreloader(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const setEditorPreloader = async ()=>{
        if (editorPreloader) {
            const preloader = await editorPreloader();
            setPreloader(preloader);
        }
    };
    const CompiledWebPanel = isATLGeneralWebPanelFixed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        ref: fixedATLGeneralWebPanelRef,
        "data-test-id": "fixed-atl-general-wrapper",
        className: (0, $35pXk.default)([
            $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['default'],
            !shouldHidePanels && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['showPanel'],
            !isNav4Enabled && isFullWidth && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['isFullWidth']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: "cache-first"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            "_4t3i1wzo"
        ])
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-test-id": "atl-general-wrapper",
        className: (0, $35pXk.default)([
            $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            shouldHidePanels && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: "cache-first"
    }));
    const CompiledPageBannerForgeApp = isForgePageBannerFixed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-test-id": "fixed-forge-page-banner-wrapper-compiled",
        ref: fixedForgePageBannerRef,
        className: (0, $35pXk.default)([
            $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['default'],
            !shouldHideForgePageBanner && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['showPanel'],
            isForgePageBannerFullWidth && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['isFullWidth']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1kZY5.RenderPageBannerForgeApps), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            "_4t3irbkl"
        ])
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            shouldHideForgePageBanner && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1kZY5.RenderPageBannerForgeApps), null));
    const EmotionWebPanel = isATLGeneralWebPanelFixed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gU0tm.FixedWebPanelWrapper), {
        ref: fixedATLGeneralWebPanelRef,
        isFullWidth: isFullWidth,
        isNav4Enabled: isNav4Enabled,
        showPanel: !shouldHidePanels,
        "data-test-id": "fixed-atl-general-wrapper",
        "data-connect-container": "fixed-atl-general-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: "cache-first"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gU0tm.FixedWebPanelSpacer), null), enableBreakoutScript && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1EzU0.BreakoutSSRInlineScript), {
        noOpSSRInlineScript: renderServerPlaceholder
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gU0tm.WebPanelWrapper), {
        showPanel: !shouldHidePanels,
        "data-test-id": "atl-general-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: "cache-first"
    }));
    const EmotionPageBannerForgeApp = isForgePageBannerFixed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gU0tm.FixedWebPanelWrapper), {
        "data-test-id": "fixed-forge-page-banner-wrapper-emotion",
        isFullWidth: isForgePageBannerFullWidth,
        isNav4Enabled: isNav4Enabled,
        showPanel: !shouldHideForgePageBanner,
        ref: fixedForgePageBannerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1kZY5.RenderPageBannerForgeApps), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gU0tm.FixedForgeBannerSpacer), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gU0tm.WebPanelWrapper), {
        showPanel: !shouldHideForgePageBanner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1kZY5.RenderPageBannerForgeApps), null));
    const AtlGeneralWebPanel = (0, $9wGTI.fg)('confluence_frontend_main_layout_compiled') ? CompiledWebPanel : EmotionWebPanel;
    const ForgePageBannerExtensionPoint = (0, $9wGTI.fg)('confluence_frontend_main_layout_compiled') ? CompiledPageBannerForgeApp : EmotionPageBannerForgeApp;
    const contentCompiled = children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        /*
         * Previously, this used to be a `<Global styles={[…]} />` from Emotion
         * But in the Compiled migration, there is no alternative and feels like the best path forward for now.
         */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $35pXk.default)([
            $4e0d0b830c02a893$var$mainContentContainerStyles['default'],
            enableRightSidebarCSS && $4e0d0b830c02a893$var$mainContentContainerStyles['enableRightSidebar'],
            !enableRightSidebarCSS && !(disableMinWidth || !enableNavigation) && $4e0d0b830c02a893$var$mainContentContainerStyles['addMinWidth'],
            isNav4Enabled && $4e0d0b830c02a893$var$mainContentContainerStyles['nav4Enabled'],
            $eYvuU.dialogStyle
        ]),
        "data-test-id": "confluence-main-content",
        "data-vc": "confluence-main-content-compiled"
    }, shouldShowATLGeneralWebPanel && AtlGeneralWebPanel, (0, $9wGTI.fg)('forge-ui-enable-confluence-page-banner') && ForgePageBannerExtensionPoint, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2DRHd.ReturnToMobile), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $3PXtn.BannerStateContainer)
        ]
    }, (bannerState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            className: (0, $35pXk.default)([
                "_16jlidpf _1o9zkb7n _i0dl1wug _19pkidpf _vchhusvi _kqswh2mm _1bsb1osq _1e0c1txw"
            ])
        }, (0, $9wGTI.fg)('confluence_frontend_content_body_container') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4e0d0b830c02a893$var$ContentBodyWithContainerTypeCompiled, {
            "data-test-id": "content-body",
            "data-vc": "content-body-with-container-type-compiled",
            id: "content-body",
            bannerHeight: bannerState.getTotalHeight(),
            style: topElementStyle
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4e0d0b830c02a893$var$ContentBodyCompiled, {
            "data-test-id": "content-body",
            "data-vc": "content-body-compiled",
            id: "content-body",
            bannerHeight: bannerState.getTotalHeight(),
            style: topElementStyle
        }, children))), !isEdit && !isLivePage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-test-id": "atl-footer-wrapper",
        className: (0, $35pXk.default)([
            $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            shouldHidePanels && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_FOOTER)
    })), (0, $9wGTI.fg)('confluence_forge_background_script') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1kZY5.RenderBackgroundScriptApps), null)))) : null;
    const contentEmotion = children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gU0tm.MainContentContainer), {
        isEnableRightSidebarEnabled: enableRightSidebarCSS,
        isNav4Enabled: (0, $9wGTI.fg)('confluence_nav_4'),
        disableMinWidth: disableMinWidth || !enableNavigation,
        "data-test-id": "confluence-main-content",
        "data-vc": "confluence-main-content-emotion"
    }, shouldShowATLGeneralWebPanel && AtlGeneralWebPanel, (0, $9wGTI.fg)('forge-ui-enable-confluence-page-banner') && ForgePageBannerExtensionPoint, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2DRHd.ReturnToMobile), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $3PXtn.BannerStateContainer)
        ]
    }, (bannerState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gU0tm.ContentBodyWrapper), null, (0, $9wGTI.fg)('confluence_frontend_content_body_container') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gU0tm.ContentBodyWithContainerType), {
            "data-test-id": "content-body",
            "data-vc": "content-body-with-container-type-emotion",
            id: "content-body",
            topElementStyle: topElementStyle,
            bannerHeight: bannerState.getTotalHeight()
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gU0tm.ContentBody), {
            "data-test-id": "content-body",
            "data-vc": "content-body-emotion",
            id: "content-body",
            topElementStyle: topElementStyle,
            bannerHeight: bannerState.getTotalHeight()
        }, children))), !isEdit && !isLivePage && /* Hides the panel's UI in non-page content types but keeps the content (vendors often use background scripts for this footer extension point) */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gU0tm.WebPanelWrapper), {
        "data-test-id": "atl-footer-wrapper",
        showPanel: !shouldHidePanels
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_FOOTER)
    }))), (0, $9wGTI.fg)('confluence_forge_background_script') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1kZY5.RenderBackgroundScriptApps), null))) : null;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
        dataFetcherName: "main-content"
    }, (0, $9wGTI.fg)('confluence_frontend_main_layout_compiled') ? contentCompiled : contentEmotion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, enableNavigation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hDG7z.PageLayout), {
        editorPreloader: preloader,
        view: navView
    }, content) : content, !(0, $9wGTI.fg)('confluence_frontend_main_layout_compiled') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gU0tm.GlobalImagePreviewStyling), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4NX9d.PerformanceEnd), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_mainLayout)
    }));
};

});
parcelRegister("hDG7z", function(module, exports) {

$parcel$export(module.exports, "PageLayout", () => $c8aadc7c03a52230$export$6d1402fb58384e4f);
//this file switches between Nav 3 and Nav 4 page-layout components. When Nav 4 is at 100% this file can simply be deleted and index can export nav 4 directly instead

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $gz8ZY = parcelRequire("gz8ZY");

const $c8aadc7c03a52230$var$Nav3Layout = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "RPrst",
    name: "Nav3Layout",
    loader: async ()=>(await (parcelRequire("a6MZG"))).PageLayout
});

const $c8aadc7c03a52230$var$Nav4Layout = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "F4Zdx",
    name: "Nav4Layout",
    loader: async ()=>(await (parcelRequire("fSnaR"))).PageLayout
});
const $c8aadc7c03a52230$export$6d1402fb58384e4f = (props)=>{
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    return isNav4Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c8aadc7c03a52230$var$Nav4Layout, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c8aadc7c03a52230$var$Nav3Layout, props);
};

});
parcelRegister("a6MZG", function(module, exports) {

let $75c07813a11b978d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $75c07813a11b978d$var$load("61J91"),
    $75c07813a11b978d$var$load("ly27m"),
    $75c07813a11b978d$var$load("gwMMy"),
    $75c07813a11b978d$var$load("hoLvO"),
    $75c07813a11b978d$var$load("jLbdY"),
    $75c07813a11b978d$var$load("9ZTsO"),
    $75c07813a11b978d$var$load("h9ALM"),
    $75c07813a11b978d$var$load("eI3Gm"),
    $75c07813a11b978d$var$load("7ZpqL"),
    $75c07813a11b978d$var$load("cZgEZ"),
    $75c07813a11b978d$var$load("ePOyH"),
    $75c07813a11b978d$var$load("gQSWJ"),
    $75c07813a11b978d$var$load("7VwsU"),
    $75c07813a11b978d$var$load("fsZ6i"),
    $75c07813a11b978d$var$load("c6MKV"),
    $75c07813a11b978d$var$load("aZinD"),
    $75c07813a11b978d$var$load("6gqpV"),
    $75c07813a11b978d$var$load("69mq0"),
    $75c07813a11b978d$var$load("bbnaa"),
    $75c07813a11b978d$var$load("9uNix"),
    $75c07813a11b978d$var$load("a6eof")
]).then(()=>parcelRequire('2xpE0'));

});

parcelRegister("fSnaR", function(module, exports) {

let $b8ede0102c3e1386$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $b8ede0102c3e1386$var$load("3XMOA"),
    $b8ede0102c3e1386$var$load("1vq4G"),
    $b8ede0102c3e1386$var$load("5SiDe"),
    $b8ede0102c3e1386$var$load("keSaw"),
    $b8ede0102c3e1386$var$load("61J91"),
    $b8ede0102c3e1386$var$load("ly27m"),
    $b8ede0102c3e1386$var$load("eYcaz"),
    $b8ede0102c3e1386$var$load("y4DZg"),
    $b8ede0102c3e1386$var$load("5epKi"),
    $b8ede0102c3e1386$var$load("kq5g1"),
    $b8ede0102c3e1386$var$load("4zTgj"),
    $b8ede0102c3e1386$var$load("9ZTsO"),
    $b8ede0102c3e1386$var$load("h9ALM"),
    $b8ede0102c3e1386$var$load("7ZpqL"),
    $b8ede0102c3e1386$var$load("cZgEZ"),
    $b8ede0102c3e1386$var$load("dH2J7"),
    $b8ede0102c3e1386$var$load("do9PF"),
    $b8ede0102c3e1386$var$load("iAspJ"),
    $b8ede0102c3e1386$var$load("9tq1O"),
    $b8ede0102c3e1386$var$load("9L8th"),
    $b8ede0102c3e1386$var$load("hRj6h"),
    $b8ede0102c3e1386$var$load("3mxtw"),
    $b8ede0102c3e1386$var$load("ePOyH"),
    $b8ede0102c3e1386$var$load("ctZCD"),
    $b8ede0102c3e1386$var$load("7VwsU"),
    $b8ede0102c3e1386$var$load("fsZ6i"),
    $b8ede0102c3e1386$var$load("6nr9L"),
    $b8ede0102c3e1386$var$load("7ofLD"),
    $b8ede0102c3e1386$var$load("6ZgMI"),
    $b8ede0102c3e1386$var$load("jWyan"),
    $b8ede0102c3e1386$var$load("7Q0UC"),
    $b8ede0102c3e1386$var$load("6StWh"),
    $b8ede0102c3e1386$var$load("bfM3g"),
    $b8ede0102c3e1386$var$load("eBvsv"),
    $b8ede0102c3e1386$var$load("ec9eQ"),
    $b8ede0102c3e1386$var$load("6gqpV"),
    $b8ede0102c3e1386$var$load("69mq0"),
    $b8ede0102c3e1386$var$load("bbnaa"),
    $b8ede0102c3e1386$var$load("9uNix"),
    $b8ede0102c3e1386$var$load("6qah4"),
    $b8ede0102c3e1386$var$load("kK8Cc"),
    $b8ede0102c3e1386$var$load("9sZ57"),
    $b8ede0102c3e1386$var$load("a8f2N"),
    $b8ede0102c3e1386$var$load("i6hfz"),
    $b8ede0102c3e1386$var$load("bMgpg"),
    $b8ede0102c3e1386$var$load("iBa9k"),
    $b8ede0102c3e1386$var$load("2oVPY"),
    $b8ede0102c3e1386$var$load("lFp1i"),
    $b8ede0102c3e1386$var$load("dLkMK"),
    $b8ede0102c3e1386$var$load("d4MuV"),
    $b8ede0102c3e1386$var$load("aZinD"),
    $b8ede0102c3e1386$var$load("cyGuT"),
    $b8ede0102c3e1386$var$load("ltGSX"),
    $b8ede0102c3e1386$var$load("1tgwx"),
    $b8ede0102c3e1386$var$load("c6MKV"),
    $b8ede0102c3e1386$var$load("i0gb6"),
    $b8ede0102c3e1386$var$load("g7QTt"),
    $b8ede0102c3e1386$var$load("gwMMy"),
    $b8ede0102c3e1386$var$load("hoLvO"),
    $b8ede0102c3e1386$var$load("gmHzx")
]).then(()=>parcelRequire('48Eol'));

});


parcelRegister("hsPwY", function(module, exports) {

$parcel$export(module.exports, "useATLGeneralWebPanelObserver", () => $9739cc17e95eb22c$export$8610b0674aff537e);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $2jjxD = parcelRequire("2jjxD");

var $eSLr0 = parcelRequire("eSLr0");

var $3jwuS = parcelRequire("3jwuS");

var $ep3mz = parcelRequire("ep3mz");

var $cEgMD = parcelRequire("cEgMD");

var $dPJCf = parcelRequire("dPJCf");

var $11b8R = parcelRequire("11b8R");

var $9wGTI = parcelRequire("9wGTI");

var $PrCoC = parcelRequire("PrCoC");
var $e4o8D = parcelRequire("e4o8D");

var $6mKj3 = parcelRequire("6mKj3");

var $dS3n9 = parcelRequire("dS3n9");

var $kXLBu = parcelRequire("kXLBu");
const $9739cc17e95eb22c$export$8610b0674aff537e = (isViewPage)=>{
    const [{ contentId: contentId, spaceKey: spaceKey, contentType: contentType }] = (0, $ep3mz.usePageState)();
    const { panels: panels } = (0, $dS3n9.useWebPanelLocation)({
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: 'cache-first',
        spaceKey: spaceKey,
        contentId: contentId
    });
    const fixedATLGeneralWebPanelRef = (0, $gwFzn.useRef)(null);
    const allAppsLoaded = (0, $gwFzn.useRef)(false);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    // For Nav 3, we expand atl.general panel to full width when the side nav is not present. This is the case for
    // company hub and when url has mode=global, such as on custom homepage
    // For Nav 4, the side nav is always present, so we have an additional check on isNav4Enabled in FixedWebPanelWrapper
    const isFullWidth = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) || routeDataRef.current?.queryParams?.mode === 'global';
    const shouldShowATLGeneralWebPanel = panels.length > 0;
    if (shouldShowATLGeneralWebPanel) {
        (0, $PrCoC.superbatchJSRecorder).includeConnectWebResources();
        (0, $PrCoC.superbatchCSSRecorder).includeConnectWebResources();
    }
    // Determines if panels should not display a UI element and only allow for the support of scripts and analytics
    const shouldHidePanels = !(0, $11b8R.isPageOrBlogPost)(contentType) && contentType;
    // If the other conditions for a fixed web panel are true, check whether the space is themed
    // The web panel should not be fixed for themed spaces since they do not have a fixed page header
    const canFixATLGeneralWebPanel = shouldShowATLGeneralWebPanel && isViewPage && !isLivePage;
    const { data: data } = (0, $diswb.useQuery)((0, $d2LG0.default)`query useATLGeneralWebPanelObserverSpaceThemeQuery($spaceKey:String){space(key:$spaceKey){id theme{themeKey}}}`, {
        skip: !canFixATLGeneralWebPanel,
        variables: {
            spaceKey: spaceKey
        }
    });
    const isATLGeneralWebPanelFixed = canFixATLGeneralWebPanel && data?.space?.theme === null;
    // ResizeObserver is needed because the height of web panel items can change at any time
    const resizeObserver = (0, $gwFzn.useMemo)(()=>{
        if (!renderServerPlaceholder) {
            if ((0, $9wGTI.fg)('confluence_preset_atl_general_height')) {
                const callback = (0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))(([entry])=>{
                    if (entry) {
                        // Remove each connect app preset dimension until all apps are loaded
                        if (!allAppsLoaded.current) allAppsLoaded.current = !!(0, $kXLBu.removeConnectAppsWrapperDimension)(entry.target);
                        // Only reset container height after all connect apps are loaded,
                        // to prevent layout shift jumping up and down
                        if (allAppsLoaded.current) {
                            document.documentElement.style.setProperty('--atl-general-webpanel-height', `${entry.target.clientHeight}px`);
                            const detail = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                                detail: {
                                    height: entry.target.clientHeight
                                }
                            } : undefined;
                            document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail));
                        }
                    }
                }, 100);
                return new ResizeObserver(callback);
            }
            return new ResizeObserver(([entry])=>{
                if (entry) {
                    document.documentElement.style.setProperty('--atl-general-webpanel-height', `${entry.target.clientHeight}px`);
                    const detail = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                        detail: {
                            height: entry.target.clientHeight
                        }
                    } : undefined;
                    document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail));
                }
            });
        }
    }, [
        renderServerPlaceholder
    ]);
    (0, $gwFzn.useLayoutEffect)(()=>{
        const fixedATLGeneralWebPanel = fixedATLGeneralWebPanelRef.current;
        let appLoadTimeoutId;
        if (!renderServerPlaceholder && isATLGeneralWebPanelFixed && fixedATLGeneralWebPanel && (0, $9wGTI.fg)('confluence_preset_atl_general_height')) {
            // Handle content types that have web panel hidden, some content types have web panel hidden,
            // so it don't need to preset wrapper dimension.
            if (shouldHidePanels) {
                document.documentElement.style.setProperty('--atl-general-webpanel-height', `0px`);
                const detail = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                    detail: {
                        height: 0
                    }
                } : undefined;
                document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail));
            } else {
                const totalHeight = (0, $kXLBu.presetConnectAppsWrapperDimension)(fixedATLGeneralWebPanel);
                if (totalHeight) {
                    document.documentElement.style.setProperty('--atl-general-webpanel-height', `${totalHeight}px`);
                    const detail = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                        detail: {
                            height: totalHeight
                        }
                    } : undefined;
                    document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail));
                }
                // If after max wait time, connect apps are still not loaded, then remove preset dimensions
                appLoadTimeoutId = setTimeout(()=>{
                    if (!allAppsLoaded.current) {
                        (0, $kXLBu.removeConnectAppsWrapperDimension)(fixedATLGeneralWebPanel, true);
                        allAppsLoaded.current = true;
                        const connectAppsWrapperContainer = fixedATLGeneralWebPanel;
                        const containerHeight = connectAppsWrapperContainer?.clientHeight || 0;
                        document.documentElement.style.setProperty('--atl-general-webpanel-height', `${containerHeight}px`);
                        const detail = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                            detail: {
                                height: containerHeight
                            }
                        } : undefined;
                        document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail));
                    }
                }, (0, $kXLBu.MAX_WAIT_TIME_REMOVE_DIMENSION));
            }
        }
        if (isATLGeneralWebPanelFixed) fixedATLGeneralWebPanel && resizeObserver?.observe(fixedATLGeneralWebPanel);
        return ()=>{
            if (isATLGeneralWebPanelFixed) fixedATLGeneralWebPanel && resizeObserver?.unobserve(fixedATLGeneralWebPanel);
            if (appLoadTimeoutId) clearTimeout(appLoadTimeoutId);
        };
    }, [
        shouldShowATLGeneralWebPanel,
        isATLGeneralWebPanelFixed,
        resizeObserver,
        renderServerPlaceholder,
        shouldHidePanels
    ]);
    return {
        shouldShowATLGeneralWebPanel: shouldShowATLGeneralWebPanel,
        isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed,
        fixedATLGeneralWebPanelRef: fixedATLGeneralWebPanelRef,
        isCompanyHub: isCompanyHub,
        isFullWidth: isFullWidth,
        shouldHidePanels: shouldHidePanels
    };
};

});
parcelRegister("11b8R", function(module, exports) {

$parcel$export(module.exports, "isPageOrBlogPost", () => $edacfc52aca854e0$export$58b315702afd1f24);
const $edacfc52aca854e0$export$58b315702afd1f24 = (contentType)=>{
    return contentType === 'page' || contentType === 'blogpost';
};

});

parcelRegister("kXLBu", function(module, exports) {

$parcel$export(module.exports, "presetConnectAppsWrapperDimension", () => $bd143360dd0cf955$export$a25046a8b24b3fc6);
$parcel$export(module.exports, "removeConnectAppsWrapperDimension", () => $bd143360dd0cf955$export$a2ff9656ed51a40a);
$parcel$export(module.exports, "MAX_WAIT_TIME_REMOVE_DIMENSION", () => $bd143360dd0cf955$export$e36afaf5515aa43);
/**
 * Parse connect app scripts width and height, and preset connect apps dimention
 * before iframe gets injected, to avoid connect apps iframe causing layout shift
 * up and down multiple times
 *
 * Return total height of connect apps rendered in a location
 * @param container - The HTMLElement contains connect apps
 * @returns {number | undefined} - Returns total height of connect apps rendered in the container
 */ const $bd143360dd0cf955$export$a25046a8b24b3fc6 = (container)=>{
    if (!document || !container) return;
    // Get all connect-app scripts at container, there can be multiple ones
    const allScripts = container.querySelectorAll('script.ap-iframe-body-script');
    if (!allScripts || allScripts.length === 0) return;
    // Total height of connect-app wrapper
    let totalHeight = 0;
    const parsePx = (matchedVal)=>{
        // Parse % or px
        let addPx = '';
        if (matchedVal.indexOf('%') === -1 && matchedVal.indexOf('px') === -1) addPx = 'px';
        return addPx;
    };
    allScripts.forEach((iframeScript)=>{
        // Get connect-app script html
        const scriptHtml = iframeScript?.innerHTML || '';
        if (scriptHtml) {
            const scriptWrapper = iframeScript.parentNode;
            // Extract connect-app height
            const matchedHeight = scriptHtml.match(/"h":\s*"(\d+(?:%|px)?)"/);
            const matchedHeightVal = matchedHeight?.[1];
            if (matchedHeightVal) {
                const matchedInt = parseInt(matchedHeightVal);
                // Add this connect-app height to total height
                if (typeof matchedInt === 'number') totalHeight += matchedInt;
                // Preset connect-app wrapper height before iframe is injected
                if (scriptWrapper) scriptWrapper.style.height = matchedHeightVal + parsePx(matchedHeightVal);
            } else // If unable to extract height value, default to 0 during iframe loading to prevent jumping,
            // this will eventually be removed after connect apps are fully loaded.
            scriptWrapper.style.height = '0px';
            //Extract connect-app width
            const matchedWidth = scriptHtml.match(/"w":\s*"(\d+(?:%|px)?)"/);
            const matchedWidthVal = matchedWidth?.[1];
            if (matchedWidthVal) // Preset connect-app wrapper height before iframe is injected
            {
                if (scriptWrapper) scriptWrapper.style.width = matchedWidthVal + parsePx(matchedWidthVal);
            }
        }
    });
    return totalHeight;
};
const $bd143360dd0cf955$export$a2ff9656ed51a40a = (container, timeout = false)=>{
    if (!document || !container) return;
    const appStatus = [];
    const allScripts = container.querySelectorAll('script.ap-iframe-body-script');
    if (!allScripts || allScripts.length === 0) return;
    // Remove each connect-app wrapper preset width and height after iframe loaded
    allScripts.forEach((iframeScript)=>{
        // Get connect-app parent
        const scriptWrapper = iframeScript.parentNode;
        const iframeLoaded = !!scriptWrapper.querySelector('iframe');
        const statusIndicator = scriptWrapper.querySelector('.ap-status-indicator');
        const timeoutIndicator = scriptWrapper.querySelector('.ap-load-timeout');
        const statusIndicatorHidden = statusIndicator?.style.display === 'none';
        // Check connect app loading status
        const isAppLoaded = iframeLoaded && (statusIndicatorHidden || timeoutIndicator);
        // Store each iframe's loading status
        appStatus.push(isAppLoaded);
        // If iframe is loaded, remove preset width and height
        if (isAppLoaded || timeout) {
            if (scriptWrapper?.style.height) scriptWrapper.style.height = '';
            if (scriptWrapper?.style.width) scriptWrapper.style.width = '';
        }
    });
    // Return if all connect apps are loaded
    return appStatus.every((status)=>status === true);
};
const $bd143360dd0cf955$export$e36afaf5515aa43 = 10000;

});


parcelRegister("9Z1sw", function(module, exports) {

$parcel$export(module.exports, "WebPanelLocation", () => $0aea74171df1eb15$export$2482f01f112556a);

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $1eaCJ = parcelRequire("1eaCJ");
var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $ep3mz = parcelRequire("ep3mz");

var $c3Qwv = parcelRequire("c3Qwv");
var $7zgzO = parcelRequire("7zgzO");

var $eSLr0 = parcelRequire("eSLr0");

var $3QyBm = parcelRequire("3QyBm");

var $gTyTP = parcelRequire("gTyTP");

var $iqPSe = parcelRequire("iqPSe");

var $8pvtc = parcelRequire("8pvtc");
const $0aea74171df1eb15$export$2482f01f112556a = ({ location: location, style: style = {}, renderWhenLoading: renderWhenLoading, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', children: children, onCompleted: onCompleted })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { getQueryParams: getQueryParams } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isTwoPageTypesExperience: isTwoPageTypesExperience } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const EXPERIENCE_NAME_BY_LOCATION = {
        [(0, $eSLr0.ATL_FOOTER)]: (0, $irVI7.EXTENSION_POINT_HOME_FOOTER_EXPERIENCE),
        [(0, $eSLr0.ATL_GENERAL)]: (0, $irVI7.EXTENSION_POINT_HOME_HEADER_EXPERIENCE),
        [(0, $eSLr0.ATL_EDITOR_SAVEBAR)]: (0, $irVI7.EXTENSION_POINT_EDITOR_SAVEBAR_EXPERIENCE)
    };
    const experienceName = EXPERIENCE_NAME_BY_LOCATION[location] || null;
    (0, $gwFzn.useEffect)(()=>{
        if (experienceName) experienceTracker.start({
            name: experienceName
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const spaceIdentifier = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, 'spaceKey') || (0, $c3Qwv.getSingleParam)(queryParams, 'key');
    const contentIdentifier = contentId || (0, $c3Qwv.getSingleParam)(queryParams, 'pageId');
    // TODO: The task to remove this hack is captured in CFE-1873.
    // There's some weird scenario where the UI ends up with a space key of "byDraft" relating to the way tinymce
    // creates content. Given that it's tinymce specific, I'm applying this hack for now and we can remove it once we're
    // at 100% rollout for the Fabric editor.
    if (spaceIdentifier === 'byDraft') return null;
    const variables = contentIdentifier ? {
        contentId: contentIdentifier,
        location: location
    } : {
        spaceKey: spaceIdentifier,
        location: location
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $j1Ss3.Query), {
        query: (0, $8pvtc.WebPanelLocationQuery),
        variables: variables,
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted
    }, ({ data: data, loading: loading, error: error })=>{
        // For transitions, loading and data is true
        if (loading && data) return null;
        if (!renderWhenLoading) {
            if (loading || error || !data) return null;
        }
        let panels = (data?.webPanels || []).filter((panel)=>panel);
        if (isTwoPageTypesExperience) panels = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, panels);
        // For panels that don't have a placeholder
        if (!renderWhenLoading && !panels.length) {
            if (experienceName) experienceTracker.succeed({
                name: experienceName
            });
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            style: style
        }, children ? children({
            panels: panels
        }) : panels.map((panel)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqPSe.WebPanel), {
                key: panel.completeKey,
                html: panel.html
            }))), experienceName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: experienceName
        }) : null);
    });
};

});
parcelRegister("3QyBm", function(module, exports) {

$parcel$export(module.exports, "filterConnectAppsFromExtensionPoints", () => $e9dc2b5b8bc8054b$export$888fec185e58bf9c);

var $4VJDS = parcelRequire("4VJDS");
const $e9dc2b5b8bc8054b$export$888fec185e58bf9c = (location, items)=>{
    const locationsToHideConnectApps = (0, $4VJDS.default).getStringList('confluence_frontend_hidden_extension_points', []);
    const loc = Array.isArray(location) ? location[0] : location;
    if (locationsToHideConnectApps.includes(loc)) items = items.filter((item)=>!item?.completeKey?.startsWith('com.atlassian.plugins.atlassian-connect-plugin:'));
    return items;
};

});

parcelRegister("iqPSe", function(module, exports) {

$parcel$export(module.exports, "WebPanel", () => $c50a10795e04dcb9$export$bbe14c99ac0820b3);
/* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */ 
var $gwFzn = parcelRequire("gwFzn");

var $brpfO = parcelRequire("brpfO");

var $9wGTI = parcelRequire("9wGTI");
function $c50a10795e04dcb9$export$bbe14c99ac0820b3({ html: html }) {
    const containerRef = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useLayoutEffect)(()=>{
        const container = containerRef.current;
        if (!container) return;
        // This is essentially a bug in React hydration. It is supposed to replace the element content with dangerouslySetInnerHTML
        // when server rendered output differs from client rendered output, but in reality it is keeping the original content.
        // Since it is keeping the original content, we need to manually check for the iframe and skip evalLegacyConnectInlineScripts
        // to avoid destroying / creating another iframe for connect webpanels.
        if (window?.__HYDRATABLE__ && (0, $9wGTI.fg)('content_early_connect_iframe_initialization')) {
            const scriptElement = container.querySelector('script.ap-iframe-body-script');
            if (scriptElement) {
                const scriptContent = scriptElement.textContent || '';
                const match = scriptContent.match(/"uniqueKey":"([^"]+)"/);
                if (match) {
                    const uniqueKey = match[1];
                    // Find iframe whose id contains the uniqueKey
                    const iframe = container.querySelector(`iframe[id*="${uniqueKey}"]`);
                    if (iframe) return;
                }
            }
        }
        (0, $brpfO.evalLegacyConnectInlineScripts)(container);
    }, [
        html
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        ref: containerRef,
        dangerouslySetInnerHTML: {
            __html: html
        }
    });
}

});


parcelRegister("fTjAG", function(module, exports) {

$parcel$export(module.exports, "useForgePageBannerObserver", () => $062cf5e7a1742c3e$export$a6ca923c8089e1e8);

var $gwFzn = parcelRequire("gwFzn");

var $2jjxD = parcelRequire("2jjxD");

var $ep3mz = parcelRequire("ep3mz");

var $cEgMD = parcelRequire("cEgMD");

var $dPJCf = parcelRequire("dPJCf");

var $11b8R = parcelRequire("11b8R");

var $3jwuS = parcelRequire("3jwuS");

var $e4o8D = parcelRequire("e4o8D");

var $9wGTI = parcelRequire("9wGTI");

var $7Ndnw = parcelRequire("7Ndnw");

var $3b6WO = parcelRequire("3b6WO");

var $6mKj3 = parcelRequire("6mKj3");
const $062cf5e7a1742c3e$export$a6ca923c8089e1e8 = (isViewPage, isNav4Enabled, isEdit)=>{
    const [{ spaceKey: spaceKey, contentType: contentType }] = (0, $ep3mz.usePageState)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { extensions: extensions } = (0, $3b6WO.useExtensionList)({
        moduleType: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER)
    });
    // For Nav 3, we expand the banner to full width when the side nav is not present. This is the case for
    // company hub and when url has mode=global, such as on custom homepage.
    // For Nav 4, the side nav is always present - so the banner is never full width)
    const isSideNavPresent = isNav4Enabled || (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) || routeDataRef.current?.queryParams?.mode === 'global';
    const { isForgePageBannerFixed: isForgePageBannerFixed, fixedForgePageBannerRef: fixedForgePageBannerRef } = $062cf5e7a1742c3e$var$useForgePageBannerObserverHelper(isViewPage, isLivePage, renderServerPlaceholder, extensions, isEdit);
    return {
        isForgePageBannerFixed: isForgePageBannerFixed,
        fixedForgePageBannerRef: fixedForgePageBannerRef,
        isForgePageBannerFullWidth: isSideNavPresent,
        shouldHideForgePageBanner: contentType && !(0, $11b8R.isPageOrBlogPost)(contentType)
    };
};
const $062cf5e7a1742c3e$var$useForgePageBannerObserverHelper = (isViewPage, isLivePage, renderServerPlaceholder, extensions, isEdit)=>{
    const fixedForgePageBannerRef = (0, $gwFzn.useRef)(null);
    const isForgePageBannerFixed = isViewPage && !isLivePage && !isEdit && extensions.length > 0; // extensions triggers a re-render
    const resizeObserver = (0, $gwFzn.useMemo)(()=>{
        if (!renderServerPlaceholder) return new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))(([entry])=>{
            if (entry) {
                document.documentElement.style.setProperty('--forge-page-banner-height', `${entry.target.clientHeight}px`);
                const detail = (0, $6mKj3.expVal)('confluence_pgxp_p2m_forge_page_banner', 'isEnabled', false) ? {
                    detail: {
                        height: entry.target.clientHeight
                    }
                } : undefined;
                document.dispatchEvent(new CustomEvent('forgePageBannerHeightUpdated', detail));
            }
        }, 100));
    }, [
        renderServerPlaceholder
    ]);
    (0, $gwFzn.useLayoutEffect)(()=>{
        if ((0, $9wGTI.fg)('forge-ui-enable-confluence-page-banner')) {
            const fixedForgePageBanner = fixedForgePageBannerRef.current;
            if (isForgePageBannerFixed) fixedForgePageBanner && resizeObserver?.observe(fixedForgePageBanner);
            return ()=>{
                fixedForgePageBanner && resizeObserver?.unobserve(fixedForgePageBanner);
            };
        }
    }, [
        isForgePageBannerFixed,
        resizeObserver,
        renderServerPlaceholder
    ]);
    return {
        isForgePageBannerFixed: isForgePageBannerFixed,
        fixedForgePageBannerRef: fixedForgePageBannerRef
    };
};

});

parcelRegister("2DRHd", function(module, exports) {

$parcel$export(module.exports, "ReturnToMobile", () => $019e7af3f6f4f87e$export$4207093557acd0c0);

var $gwFzn = parcelRequire("gwFzn");

var $7zgzO = parcelRequire("7zgzO");

var $7D0B0 = parcelRequire("7D0B0");
class $019e7af3f6f4f87e$export$4207093557acd0c0 extends (0, $gwFzn.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ getQueryParams: getQueryParams, setQueryParams: setQueryParams })=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7D0B0.ReturnToMobileComponent), {
                getQueryParams: getQueryParams,
                setQueryParams: setQueryParams,
                ...this.props
            });
        });
    }
}

});
parcelRegister("7D0B0", function(module, exports) {

$parcel$export(module.exports, "ReturnToMobileComponent", () => $796a872a5806d472$export$5945f0cd1996f6fc);
/* ReturnToMobileComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $1DWH0 = parcelRequire("1DWH0");

var $68uaC = parcelRequire("68uaC");

var $8dwdz = parcelRequire("8dwdz");

var $jlIaF = parcelRequire("jlIaF");
function $796a872a5806d472$var$_defineProperty(e, r, t) {
    return (r = $796a872a5806d472$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $796a872a5806d472$var$_toPropertyKey(t) {
    var i = $796a872a5806d472$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $796a872a5806d472$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $796a872a5806d472$var$returnLinkContainer = null;
const $796a872a5806d472$export$5945f0cd1996f6fc = (0, $1DWH0.default)()(class ReturnToMobileComponent extends (0, $gwFzn.PureComponent) {
    componentDidMount() {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const { isSupportedUserAgent: isSupportedUserAgent } = this.state;
        if (isSupportedUserAgent && createAnalyticsEvent) {
            const analyticsData = {
                source: 'mobileWebView',
                action: 'visited',
                actionSubject: 'page'
            };
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: analyticsData
            }).fire();
        }
    }
    isDesktopSwitchRequired() {
        // Port from com.atlassian.confluence.mobile.MobileUtils#isDesktopSwitchRequired
        const { getQueryParams: getQueryParams } = this.props;
        const { desktop: desktop } = getQueryParams();
        return (0, $68uaC.Cookies).get('confluence.mobile.desktop.switch') === 'true' || desktop === 'true';
    }
    render() {
        const { isSupportedUserAgent: isSupportedUserAgent, isDesktopOverride: isDesktopOverride } = this.state; // Only show this if the user is on a mobile device and has explicitly chosen to show desktop
        if (isSupportedUserAgent && isDesktopOverride) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            className: (0, $35pXk.default)([
                "_1yt4pxbi _11q7m7j4 _y3gn1h6o"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            id: "return-to-mobile.nav.switch.to.mobile.text",
            defaultMessage: "You are viewing the desktop version of Confluence on a mobile supported device."
        }), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", {
            href: "#",
            onClick: this.onSwitchClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            id: "return-to-mobile.nav.switch.to.mobile.action",
            defaultMessage: "Switch to Confluence Mobile"
        })));
        return null;
    }
    constructor(...args){
        super(...args);
        $796a872a5806d472$var$_defineProperty(this, "state", {
            isSupportedUserAgent: (0, $8dwdz.isMobileUserAgent)(),
            // If the mobile SPA is handling mobile view, we need to check local storage
            // TODO: Remove the call to isDesktopSwitchRequired once mobile-plugin is dead
            isDesktopOverride: this.isDesktopSwitchRequired() || (0, $8dwdz.isDesktopOverrideActive)()
        });
        $796a872a5806d472$var$_defineProperty(this, "onSwitchClick", ()=>{
            const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = this.props; // If the backend filter has not set a cookie, we need to remove it from local storage (the new way)
            // TODO: Remove the call to isDesktopSwitchRequired once mobile-plugin is dead
            if (!this.isDesktopSwitchRequired()) (0, $8dwdz.deactivateDesktopOverride)();
            else // Otherwise, we need to remove the cookie
            (0, $68uaC.Cookies).remove('confluence.mobile.desktop.switch', {
                path: (0, $jlIaF.CONTEXT_PATH)
            });
            const queryParams = getQueryParams(); // remove the desktop=true request parameter if it is present
            if (queryParams.desktop === 'true') {
                queryParams.desktop = null; // setQueryParams removes null values
                setQueryParams(queryParams, true);
            } else window.location.reload();
        });
    }
});

});


parcelRegister("4NX9d", function(module, exports) {

$parcel$export(module.exports, "PerformanceEnd", () => $6182ff2f7ce21920$export$c7a09306845216e0);

var $fppBw = parcelRequire("fppBw");

var $gwFzn = parcelRequire("gwFzn");

var $9eE57 = parcelRequire("9eE57");
class $6182ff2f7ce21920$export$c7a09306845216e0 extends (0, $gwFzn.Component) {
    componentDidMount() {
        (0, $9eE57.perfMarkEnd)(this.props);
    }
    render() {
        return null;
    }
}
$6182ff2f7ce21920$export$c7a09306845216e0.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    details: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object,
    includeFeatureFlags: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool
};
$6182ff2f7ce21920$export$c7a09306845216e0.defaultProps = {
    subjectId: '',
    includeFeatureFlags: false
};

});

parcelRegister("jln20", function(module, exports) {

$parcel$export(module.exports, "useRightSidebarContext", () => $8facebd0ecb5e0ee$export$8c38c254c6602904);
$parcel$export(module.exports, "RightSidebarContextProvider", () => $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f);

var $gwFzn = parcelRequire("gwFzn");

var $2QMNQ = parcelRequire("2QMNQ");
var $8gtQ7 = parcelRequire("8gtQ7");

var $aWwYt = parcelRequire("aWwYt");

var $9wGTI = parcelRequire("9wGTI");
function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            if ((0, $9wGTI.fg)('confluence_frontend_object_sidebar')) hideObjectSidebar();
            if (isPreviewPanelOpen && (0, $9wGTI.fg)('confluence_preview_panels')) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = ()=>(0, $gwFzn.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = ({ children: children })=>{
    const [sidebars, setSidebars] = (0, $gwFzn.useState)([]);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $gwFzn.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $8gtQ7.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $2QMNQ.useIsPreviewPanelOpen)();
    const contextValue = (0, $gwFzn.useMemo)(()=>$8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        }), [
        sidebars,
        triggerButtonRef,
        hideObjectSidebar,
        hidePreviewPanel,
        isPreviewPanelOpen
    ]);
    (0, $gwFzn.useEffect)(()=>{
        const handleCloseGlobalSidebar = ()=>{
            setSidebars([]);
        };
        // Register the global window event when the component mounts
        window.addEventListener('closeGlobalSidebar', handleCloseGlobalSidebar);
        return ()=>{
            // Unregister the global window event when the component unmounts
            window.removeEventListener('closeGlobalSidebar', handleCloseGlobalSidebar);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
        value: contextValue
    }, children);
};

});
parcelRegister("2QMNQ", function(module, exports) {

$parcel$export(module.exports, "PreviewPanelsProvider", () => $0fe21c36979e0689$export$65ae37e9c61321f9);
$parcel$export(module.exports, "usePreviewPanelsContext", () => $0fe21c36979e0689$export$609db4be92d0fad8);
$parcel$export(module.exports, "useIsPreviewPanelOpen", () => $0fe21c36979e0689$export$c68e55e6e77f3d5d);
$parcel$export(module.exports, "useCurrentPreviewPanel", () => $0fe21c36979e0689$export$5351114e92b31bc6);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $iJRU1 = parcelRequire("iJRU1");
const $0fe21c36979e0689$export$f473d225913e225d = /*#__PURE__*/ (0, $gwFzn.createContext)(undefined);
const $0fe21c36979e0689$export$35041b83145053c1 = (state, action)=>{
    switch(action.type){
        case 'SET_PANEL_WIDTH':
            return {
                ...state,
                width: action.width
            };
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.closePanelSlot?.();
            return 0, $iJRU1.initialState;
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel.id === params.panel.id) return state;
            // Close the active panel.
            state.onClose();
            state.closePanelSlot?.();
            // Open the new panel.
            state.openPanelSlot?.();
            params.onOpen?.();
            return {
                ...state,
                panel: params.panel,
                width: params.width || (0, $iJRU1.initialState).width,
                onOpen: params.onOpen || (0, $iJRU1.initialState).onOpen,
                onClose: params.onClose || (0, $iJRU1.initialState).onClose
            };
        default:
            return state;
    }
};
const $0fe21c36979e0689$export$65ae37e9c61321f9 = ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, children: children })=>{
    (0, $iJRU1.initialState).closePanelSlot = onPreviewPanelClose;
    (0, $iJRU1.initialState).openPanelSlot = onPreviewPanelOpen;
    const [state, dispatch] = (0, $gwFzn.useReducer)($0fe21c36979e0689$export$35041b83145053c1, (0, $iJRU1.initialState));
    const context = (0, $gwFzn.useMemo)(()=>({
            state: state,
            dispatch: dispatch
        }), [
        state,
        dispatch
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($0fe21c36979e0689$export$f473d225913e225d.Provider, {
        value: context,
        children: children
    });
};
const $0fe21c36979e0689$export$609db4be92d0fad8 = ()=>{
    const context = (0, $gwFzn.useContext)($0fe21c36979e0689$export$f473d225913e225d);
    return context;
};
const $0fe21c36979e0689$export$c68e55e6e77f3d5d = (panelId)=>{
    const context = $0fe21c36979e0689$export$609db4be92d0fad8();
    return panelId ? context?.state.panel.id === panelId : !!context?.state.panel.id;
};
const $0fe21c36979e0689$export$5351114e92b31bc6 = ()=>{
    const context = $0fe21c36979e0689$export$609db4be92d0fad8();
    return context?.state.panel ?? (0, $iJRU1.initialState).panel;
};

});
parcelRegister("iJRU1", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $85f43b535c1c3f9c$export$d4c72bab9d6cc13a);
const $85f43b535c1c3f9c$export$d4c72bab9d6cc13a = {
    // Configured by the product to allow for nuances in how the
    // product handles opening and closing of the preview panel.
    closePanelSlot: ()=>{},
    openPanelSlot: ()=>{},
    // Configured when opening a panel.
    panel: {
        id: '',
        content: undefined
    },
    width: 400,
    onOpen: ()=>{},
    onClose: ()=>{}
};

});


parcelRegister("8gtQ7", function(module, exports) {

$parcel$export(module.exports, "usePreviewPanelsActions", () => $1e5215e1f439a288$export$5f5debba1692bf40);

var $gwFzn = parcelRequire("gwFzn");

var $2QMNQ = parcelRequire("2QMNQ");
const $1e5215e1f439a288$export$5f5debba1692bf40 = ()=>{
    const context = (0, $2QMNQ.usePreviewPanelsContext)();
    const dispatch = context?.dispatch;
    const setPanelWidth = (0, $gwFzn.useCallback)((width)=>{
        dispatch?.({
            type: 'SET_PANEL_WIDTH',
            width: width
        });
    }, [
        dispatch
    ]);
    const close = (0, $gwFzn.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
    }, [
        dispatch
    ]);
    const open = (0, $gwFzn.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
    }, [
        dispatch
    ]);
    return {
        setPanelWidth: setPanelWidth,
        close: close,
        open: open
    };
};

});

parcelRegister("aWwYt", function(module, exports) {

$parcel$export(module.exports, "MIN_PANEL_WIDTH", () => $5371993c50b87836$export$9e0a6941e0e87c97);
$parcel$export(module.exports, "useObjectSidebarActions", () => $5371993c50b87836$export$332594c77a860a26);
$parcel$export(module.exports, "useObjectSidebarState", () => $5371993c50b87836$export$41c5dcc793387db5);
$parcel$export(module.exports, "useIsObjectSidebarShown", () => $5371993c50b87836$export$a572d51222d5ea45);
$parcel$export(module.exports, "usePanel", () => $5371993c50b87836$export$9168a42f32e3d071);
$parcel$export(module.exports, "useBehavior", () => $5371993c50b87836$export$8b43142d6fd506da);
$parcel$export(module.exports, "useIsPanelScrolled", () => $5371993c50b87836$export$ec8631e69ae8c803);
$parcel$export(module.exports, "usePanelWidth", () => $5371993c50b87836$export$82b270f291af5a5);
$parcel$export(module.exports, "useUpdatedHeaderComponentElements", () => $5371993c50b87836$export$bc4f8f2fe52e3d40);
$parcel$export(module.exports, "useSidebarControlState", () => $5371993c50b87836$export$d4d7180dad517777);
$parcel$export(module.exports, "useSidebarControlExpandCollapsedState", () => $5371993c50b87836$export$b00fb66a9723fc58);

var $gwFzn = parcelRequire("gwFzn");

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");

var $8gtQ7 = parcelRequire("8gtQ7");

var $9wGTI = parcelRequire("9wGTI");
const $5371993c50b87836$export$c0cd7aea5be0e780 = 40;
const $5371993c50b87836$export$9e0a6941e0e87c97 = 400;
const $5371993c50b87836$export$70e5631b7ec2f387 = Math.max($5371993c50b87836$export$9e0a6941e0e87c97, 368) + $5371993c50b87836$export$c0cd7aea5be0e780;
const $5371993c50b87836$export$d4c72bab9d6cc13a = {
    isPanelScrolled: false,
    isObjectSidebarShown: false,
    behavior: 'push',
    panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
    panel: undefined,
    updatedPanelHeaderComponentElements: undefined,
    sidebarControlState: window.__SSR_RENDERED__ ? 'shown' : 'hidden',
    sidebarControlExpandCollapsedState: window.__SSR_RENDERED__ ? 'expanded' : 'collapsed'
};
const $5371993c50b87836$export$e324594224ef24da = {
    setIsPanelScrolled: (isPanelScrolled)=>({ setState: setState })=>{
            setState({
                isPanelScrolled: isPanelScrolled
            });
        },
    setSidebarControlState: (sidebarControlState)=>({ setState: setState })=>{
            setState({
                sidebarControlState: sidebarControlState
            });
        },
    setSidebarControlExpandCollapsedState: (sidebarControlExpandCollapsedState)=>({ setState: setState })=>{
            setState({
                sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState
            });
        },
    toggleObjectSidebarControl: ()=>({ setState: setState, getState: getState })=>{
            const { sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState } = getState();
            if (sidebarControlExpandCollapsedState === 'collapsed') setState({
                sidebarControlExpandCollapsedState: 'expanded'
            });
            else setState({
                sidebarControlExpandCollapsedState: 'collapsed'
            });
        },
    showObjectSidebar: (panel, behavior, panelWidth)=>({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: currentPanel, behavior: currentBehavior, panelWidth: currentPanelWidth } = getState();
            // Check if panel is open
            if (isObjectSidebarShown) {
                // If it's the same panel do nothing
                if (currentPanel?.id === panel.id) return;
                // Otherwise change it
                setState({
                    panel: panel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: behavior ?? currentBehavior,
                    panelWidth: panelWidth ?? currentPanelWidth,
                    isPanelScrolled: false
                });
            }
            // Set the panel to be open
            setState({
                isObjectSidebarShown: true,
                panel: panel,
                updatedPanelHeaderComponentElements: undefined,
                behavior: behavior ?? currentBehavior,
                panelWidth: panelWidth ?? currentPanelWidth,
                sidebarControlState: 'hidden',
                isPanelScrolled: false
            });
            // Close the global panel
            window.dispatchEvent(new Event('closeGlobalSidebar'));
        },
    hideObjectSidebar: (afterCloseCallback)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            // If we're not showing a panel, don't do anything
            if (!isObjectSidebarShown || !panel) return;
            // If the user has provided closeOptions check them
            if (panel.closeOptions) {
                const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                // If the panel closing check returns false, do nothing
                if (canClosePanel) {
                    const panelCanClose = await canClosePanel();
                    if (!panelCanClose) return;
                }
                // Call the onClose callback
                onPanelClose && onPanelClose();
            }
            // Close the panel
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
            if (afterCloseCallback) afterCloseCallback();
        },
    hideObjectSidebarByPanelId: (id)=>({ getState: getState, dispatch: dispatch })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) dispatch($5371993c50b87836$export$e324594224ef24da.hideObjectSidebar());
        },
    setPanelWidth: (newPanelWidth)=>({ setState: setState })=>{
            setState({
                panelWidth: Math.max(newPanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97) + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    changePanelBehavior: (newBehavior)=>({ setState: setState, getState: getState })=>{
            const { panelWidth: panelWidth } = getState();
            // When we set the new state, if it's set to cover, we no longer have a
            // component that will size the panel accordingly so we just use the default
            setState({
                behavior: newBehavior,
                panelWidth: newBehavior === 'cover' ? $5371993c50b87836$export$70e5631b7ec2f387 : panelWidth
            });
        },
    changePanel: (newPanel, newBehavior, newPanelWidth)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel, behavior: behavior, panelWidth: panelWidth } = getState();
            // Only change panels if the panel is open
            if (isObjectSidebarShown && panel) {
                // If it's the same panel do nothing
                if (panel.id === newPanel.id) return;
                // If the user has provided closeOptions check them
                if (panel.closeOptions) {
                    const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                    // If the panel closing check returns false, do nothing
                    if (canClosePanel) {
                        const panelCanClose = await canClosePanel();
                        if (!panelCanClose) return;
                    }
                    // Call the onClose callback
                    onPanelClose && onPanelClose();
                }
                setState({
                    panel: newPanel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: newBehavior ?? behavior,
                    panelWidth: newPanelWidth ?? panelWidth,
                    isPanelScrolled: false
                });
            }
        // Otherwise do nothing
        },
    changeHeaderElements: (id, headerComponentElements)=>({ setState: setState, getState: getState })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) setState({
                updatedPanelHeaderComponentElements: headerComponentElements
            });
        }
};
const $5371993c50b87836$export$8930ecd60eb3f136 = (0, $4ZoIm.createStore)({
    initialState: $5371993c50b87836$export$d4c72bab9d6cc13a,
    actions: $5371993c50b87836$export$e324594224ef24da,
    name: 'ObjectSidebarStore'
});
const $5371993c50b87836$var$useObjectSidebarActionsInternal = (0, $iFWZA.createActionsHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$export$332594c77a860a26 = ()=>{
    const internalActions = $5371993c50b87836$var$useObjectSidebarActionsInternal();
    const { close: close } = (0, $8gtQ7.usePreviewPanelsActions)();
    const showObjectSidebarWrapper = (0, $gwFzn.useCallback)((panel, behavior, panelWidth)=>{
        internalActions.showObjectSidebar(panel, behavior, panelWidth);
        close();
    }, [
        internalActions,
        close
    ]);
    const showObjectSidebar = (0, $gwFzn.useMemo)(()=>(0, $9wGTI.fg)('confluence_preview_panels') ? showObjectSidebarWrapper : internalActions.showObjectSidebar, [
        showObjectSidebarWrapper,
        internalActions.showObjectSidebar
    ]);
    const memoizedActions = (0, $gwFzn.useMemo)(()=>({
            ...internalActions,
            showObjectSidebar: showObjectSidebar
        }), [
        internalActions,
        showObjectSidebar
    ]);
    return (0, $gwFzn.useMemo)(()=>memoizedActions, [
        memoizedActions
    ]);
};
const $5371993c50b87836$export$41c5dcc793387db5 = (0, $iFWZA.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$var$getIsObjectSidebarShown = (state)=>state.isObjectSidebarShown;
const $5371993c50b87836$var$getPanel = (state)=>state.panel;
const $5371993c50b87836$var$getBehavior = (state)=>state.behavior;
const $5371993c50b87836$var$isPanelScrolled = (state)=>state.isPanelScrolled;
const $5371993c50b87836$var$getPanelWidth = (state)=>state.panelWidth;
const $5371993c50b87836$var$getUpdatedHeaderComponentElements = (state)=>state.updatedPanelHeaderComponentElements;
const $5371993c50b87836$var$getSidebarControlState = (state)=>state.sidebarControlState;
const $5371993c50b87836$var$getSidebarControlExpandCollapsedState = (state)=>state.sidebarControlExpandCollapsedState;
const $5371993c50b87836$export$a572d51222d5ea45 = (0, $iFWZA.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getIsObjectSidebarShown
});
const $5371993c50b87836$export$9168a42f32e3d071 = (0, $iFWZA.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanel
});
const $5371993c50b87836$export$8b43142d6fd506da = (0, $iFWZA.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getBehavior
});
const $5371993c50b87836$export$ec8631e69ae8c803 = (0, $iFWZA.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$isPanelScrolled
});
const $5371993c50b87836$export$82b270f291af5a5 = (0, $iFWZA.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanelWidth
});
const $5371993c50b87836$export$bc4f8f2fe52e3d40 = (0, $iFWZA.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getUpdatedHeaderComponentElements
});
const $5371993c50b87836$export$d4d7180dad517777 = (0, $iFWZA.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlState
});
const $5371993c50b87836$export$b00fb66a9723fc58 = (0, $iFWZA.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlExpandCollapsedState
});

});


parcelRegister("8zMP3", function(module, exports) {

$parcel$export(module.exports, "SuspenseWithDataFetcher", () => $5cfe2edd168ef31e$export$553ede96e278ba94);

var $gwFzn = parcelRequire("gwFzn");
parcelRequire("fPnFe");

var $eS4vC = parcelRequire("eS4vC");
function $5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader({ dataFetcher: dataFetcher, children: children }) {
    dataFetcher?.read();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
}
function $5cfe2edd168ef31e$export$553ede96e278ba94({ dataFetcherName: dataFetcherName, fallback: fallback = null, children: children }) {
    const initializedRef = (0, $gwFzn.useRef)(false);
    const dataFetcher = (0, $eS4vC.getDataFetcherForSuspense)(dataFetcherName);
    if (window.__SSR_REACT_STREAMING__) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Suspense), {
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader, {
        dataFetcher: dataFetcher
    }, children));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
}

});
parcelRegister("eS4vC", function(module, exports) {

$parcel$export(module.exports, "getDataFetcherForSuspense", () => $a98f386ac75dbb32$export$63116239d47be9ca);
$parcel$export(module.exports, "createDataFetcherForSuspense", () => $a98f386ac75dbb32$export$51ac369f090007c2);

var $fPnFe = parcelRequire("fPnFe");

let $a98f386ac75dbb32$var$mockSuspenseDelayAccumulated = 0;
function $a98f386ac75dbb32$export$63116239d47be9ca(dataFetcherName) {
    if (!window.__SSR_REACT_STREAMING__) return null;
    const dataFetcher = window.__dataFetcherForSuspense__?.[dataFetcherName] ?? null;
    if (!dataFetcher) {
        if (!window.__dataFetcherForSuspense__) window.__dataFetcherForSuspense__ = {};
        let pendingResolve = false;
        const dataFetcher = $a98f386ac75dbb32$export$728d3ea8195fe601(dataFetcherName, new Promise((resolve)=>{
            // Please note done here does NOT mean successful. It could be server-side errored.
            // In that case we will resume hydration so that normal Apollo error handling can take care of it.
            (0, $fPnFe.getClientStream)('data-fetcher-done').addListener((event)=>{
                if (event.name === dataFetcherName) {
                    pendingResolve = true;
                    resolve();
                }
            });
        }));
        // addListener will get called synchronously when an event already presented before the listener is added.
        // In this case .read() is still pending but we actually have the result already.
        if (pendingResolve) {
            pendingResolve = false;
            // We are not passing result to client for now. Only signaling the done.
            dataFetcher.update('resolved', undefined);
        }
        return window.__dataFetcherForSuspense__[dataFetcherName] = dataFetcher;
    }
    return dataFetcher;
}
function $a98f386ac75dbb32$export$51ac369f090007c2(dataFetcherName, promise) {
    promise = promise ?? Promise.resolve();
    if (Array.isArray(promise)) promise = Promise.all(promise);
    if (!window.__SSR_REACT_STREAMING__) return promise;
    if (!window.__dataFetcherForSuspense__) window.__dataFetcherForSuspense__ = {};
    const dataFetcher = window.__dataFetcherForSuspense__[dataFetcherName];
    if (!dataFetcher) {
        const urlParams = new URLSearchParams(window.location.search);
        const mockDelay = urlParams.get('MOCK_SUSPENSE_QUERYDELAY');
        // If MOCK_SUSPENSE_QUERYDELAY = 1000, we want first data fetcher to have delay of 1000ms then second one to have 2000ms
        // In this case, we can see the suspense is really working. They should appear piece by piece.
        $a98f386ac75dbb32$var$mockSuspenseDelayAccumulated += mockDelay ? parseInt(mockDelay) : 0;
        window.__dataFetcherForSuspense__[dataFetcherName] = $a98f386ac75dbb32$export$728d3ea8195fe601(dataFetcherName, promise, $a98f386ac75dbb32$var$mockSuspenseDelayAccumulated);
    }
    return Promise.resolve();
}
function $a98f386ac75dbb32$export$b4f7405efb61c06d() {
    $a98f386ac75dbb32$var$mockSuspenseDelayAccumulated = 0;
}
function $a98f386ac75dbb32$export$728d3ea8195fe601(dataFetcherName, promise, delay = 0) {
    let dataResult = null;
    let errorResult = null;
    let promiseState = 'pending';
    const suspender = new Promise((resolve)=>{
        promise.then((result)=>{
            if (delay > 0) setTimeout(()=>{
                dataResult = result;
                promiseState = 'resolved';
                resolve();
            }, delay);
            else {
                dataResult = result;
                promiseState = 'resolved';
                resolve();
            }
        }).catch((error)=>{
            error.dataFetcherName = dataFetcherName;
            errorResult = error;
            promiseState = 'error';
            resolve();
        });
    });
    return {
        get () {
            return suspender;
        },
        getError () {
            return errorResult;
        },
        getState () {
            return promiseState;
        },
        update (state, result) {
            promiseState = state;
            if (state === 'resolved') dataResult = result;
            else if (state === 'error') errorResult = result;
        },
        read () {
            if (promiseState === 'pending') throw suspender;
            else if (promiseState === 'error') // Data fetcher is a wrapper of preloader. If an error happened we don't want to blow up the tree too early.
            // Return null here to signal the Suspense to continue.
            // The normal error handling in the component will take care of it.
            return null;
            else if (promiseState === 'resolved') return dataResult;
        }
    };
}

});


parcelRegister("eYvuU", function(module, exports) {

$parcel$export(module.exports, "dialogStyle", () => $ae6f1a0e4a2e28fc$export$da31f8cf16ec20db, (v) => $ae6f1a0e4a2e28fc$export$da31f8cf16ec20db = v);
var $ae6f1a0e4a2e28fc$export$da31f8cf16ec20db;
$ae6f1a0e4a2e28fc$export$da31f8cf16ec20db = `OsGcuW_dialogStyle`;

});

parcelRegister("1EzU0", function(module, exports) {

$parcel$export(module.exports, "BreakoutSSRInlineScript", () => $bd51a8c87efeb5a5$export$cfc1361be0de4203);

var $gwFzn = parcelRequire("gwFzn");

var $kXLBu = parcelRequire("kXLBu");
function $bd51a8c87efeb5a5$export$cfc1361be0de4203({ noOpSSRInlineScript: noOpSSRInlineScript }) {
    /**
	 * Should only inline this script while SSR,
	 * not needed on the client side.
	 */ // For hydrateRoot there is a mismatch on client for this script.
    // So we want to add the script on client side but guard it with check to
    // not execute logic
    if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
        if (!noOpSSRInlineScript) return null;
        else window.__RENDERER_BYPASS_BREAKOUT_SSR__ = true;
    }
    const context = $bd51a8c87efeb5a5$export$92859d13f30c883e();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("script", {
        // To investigate if we can replace this.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: context
        }
    });
}
function $bd51a8c87efeb5a5$export$92859d13f30c883e() {
    return `
  (function(window){
		if(typeof window !== 'undefined' && window.__RENDERER_BYPASS_BREAKOUT_SSR__) {
			return;
		}
		${$bd51a8c87efeb5a5$export$47813c4121c8b4b3};
    (${$bd51a8c87efeb5a5$export$a125785b9fe77113.toString()})(breakoutConstsInner);
  })(window);
 `;
}
const $bd51a8c87efeb5a5$export$47813c4121c8b4b3 = `
	var breakoutConstsInner = {}; 
  breakoutConstsInner.presetConnectAppsWrapperDimension = ${(0, $kXLBu.presetConnectAppsWrapperDimension).toString()};
`;
function $bd51a8c87efeb5a5$export$a125785b9fe77113(breakoutConstsInner) {
    const breakoutContainer = document.querySelector("[data-connect-container='fixed-atl-general-wrapper']");
    if (!breakoutContainer) return;
    const totalHeight = breakoutConstsInner?.presetConnectAppsWrapperDimension(breakoutContainer);
    if (totalHeight) {
        document.documentElement.style.setProperty('--atl-general-webpanel-height', `${totalHeight}px`);
        document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated'));
        window['__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__'] = totalHeight;
    }
}

});

parcelRegister("1kZY5", function(module, exports) {

$parcel$export(module.exports, "RenderBackgroundScriptApps", () => $b7830f7e8969acd1$export$f0362fceef532aae);
$parcel$export(module.exports, "RenderPageBannerForgeApps", () => $b7830f7e8969acd1$export$910fc80855ba5fda);
/* ForgeApps.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $dIouf = parcelRequire("dIouf");

var $irVI7 = parcelRequire("irVI7");
var $ln0hx = parcelRequire("ln0hx");

var $7Sm4c = parcelRequire("7Sm4c");

var $7QUD1 = parcelRequire("7QUD1");
var $7Ndnw = parcelRequire("7Ndnw");
var $8a9Dm = parcelRequire("8a9Dm");
var $hIaUw = parcelRequire("hIaUw");
var $dizL5 = parcelRequire("dizL5");

var $3jwuS = parcelRequire("3jwuS");

var $ep3mz = parcelRequire("ep3mz");

var $6uUjl = parcelRequire("6uUjl");
const $b7830f7e8969acd1$var$invisible = null;
const $b7830f7e8969acd1$export$afbabe4d2446fca2 = (forgeModules, loading, error)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ contentId: contentId, routeName: routeName, spaceKey: spaceAlias }] = (0, $ep3mz.usePageState)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    if (loading) return null;
    if (error) {
        if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
            error: error
        });
        return null;
    }
    return forgeModules.map((0, $dIouf.withErrorBoundary)({
        attribution: (0, $dIouf.Attribution).ECOSYSTEM
    })((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
            key: (0, $8a9Dm.getAppId)(app),
            attributes: {
                appId: (0, $8a9Dm.getAppId)(app)
            },
            attribution: (0, $dIouf.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            className: (0, $35pXk.default)([
                "_1e0cglyw"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.BACKGROUND_SCRIPT_APPS_FORGE_EXPERIENCE),
            id: (0, $8a9Dm.getAppId)(app)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7QUD1.BackgroundScriptForgeApp), {
            app: app,
            // Adding the pageRoute to the extensionData will allow the Forge app to re-render when the route changes
            extensionData: {
                type: (0, $7Ndnw.FORGE_MODULE_BACKGROUND_SCRIPT),
                ...contentId ? {
                    content: {
                        id: contentId,
                        type: (0, $hIaUw.getContentType)(routeName),
                        subtype: isLivePage ? 'live' : null
                    }
                } : {},
                ...spaceKey || spaceAlias ? {
                    space: {
                        id: spaceId,
                        key: spaceKey || spaceAlias
                    }
                } : {}
            }
        })))));
};
const $b7830f7e8969acd1$export$f0362fceef532aae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_BACKGROUND_SCRIPT),
        render: $b7830f7e8969acd1$export$afbabe4d2446fca2
    }); // This is exported solely for testing purposes
const $b7830f7e8969acd1$export$d778357d5618ef80 = (forgeModules, loading, error)=>{
    const [{ contentId: contentId, routeName: routeName, spaceKey: spaceAlias }] = (0, $ep3mz.usePageState)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    if (loading) return null;
    if (error) {
        if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
            error: error
        });
        return null;
    }
    return forgeModules.map((0, $dIouf.withErrorBoundary)({
        attribution: (0, $dIouf.Attribution).ECOSYSTEM
    })((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
            key: (0, $8a9Dm.getAppId)(app),
            attributes: {
                appId: (0, $8a9Dm.getAppId)(app)
            },
            attribution: (0, $dIouf.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7QUD1.PageBannerForgeApp), {
            app: app,
            extensionData: {
                type: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER),
                ...contentId ? {
                    content: {
                        id: contentId,
                        type: (0, $hIaUw.getContentType)(routeName),
                        subtype: isLivePage ? 'live' : null
                    }
                } : {},
                ...spaceKey || spaceAlias ? {
                    space: {
                        id: spaceId,
                        key: spaceKey || spaceAlias
                    }
                } : {}
            }
        }))));
};
const $b7830f7e8969acd1$export$910fc80855ba5fda = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER),
        render: $b7830f7e8969acd1$export$d778357d5618ef80
    });
};

});
parcelRegister("ln0hx", function(module, exports) {

$parcel$export(module.exports, "ExperienceStart", () => $0c8ceb2bfbb43f95$export$f20b867e738a222c);

var $gwFzn = parcelRequire("gwFzn");

var $1kHsc = parcelRequire("1kHsc");
function $0c8ceb2bfbb43f95$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const wasCalledRef = (0, $gwFzn.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}

});

parcelRegister("7QUD1", function(module, exports) {

$parcel$export(module.exports, "ByLineForgeApp", () => $02976f123c8f8e25$export$d2159b9f3f077903);
$parcel$export(module.exports, "ContentActionForgeApp", () => $02976f123c8f8e25$export$f900958ce7c4410f);
$parcel$export(module.exports, "ContextMenuForgeApp", () => $02976f123c8f8e25$export$79ed117743c6c2cf);
$parcel$export(module.exports, "GlobalPageForgeApp", () => $02976f123c8f8e25$export$83db8797814193a8);
$parcel$export(module.exports, "GlobalSettingsForgeApp", () => $02976f123c8f8e25$export$74528162c4c3828b);
$parcel$export(module.exports, "HomepageFeedForgeApp", () => $02976f123c8f8e25$export$c8291e2d6d6adbf2);
$parcel$export(module.exports, "SpaceSettingsForgeApp", () => $02976f123c8f8e25$export$e8858129e933f7e8);
$parcel$export(module.exports, "CustomContentForgeApp", () => $02976f123c8f8e25$export$578d0cbdb0ffa72e);
$parcel$export(module.exports, "BackgroundScriptForgeApp", () => $02976f123c8f8e25$export$40d4b5cfa6c18ea7);
$parcel$export(module.exports, "PageBannerForgeApp", () => $02976f123c8f8e25$export$c76787f94e0b1609);

var $jmjWc = parcelRequire("jmjWc");

const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("an4YM"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("kKR9r"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("jPIxF"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("jnGIw"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("i7DKB"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("3aUdO"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("fkiDa"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("eOKNB"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("2Oy3K"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("5Cn12"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("851Aj"))).PageBannerForgeApp
});

});
parcelRegister("an4YM", function(module, exports) {

let $78cfea2b71520c0e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $78cfea2b71520c0e$var$load("7Q0UC"),
    $78cfea2b71520c0e$var$load("hf7yW"),
    $78cfea2b71520c0e$var$load("2HRN3"),
    $78cfea2b71520c0e$var$load("hZSgn"),
    $78cfea2b71520c0e$var$load("lnKog"),
    $78cfea2b71520c0e$var$load("2aE9V"),
    $78cfea2b71520c0e$var$load("iQ0Jm"),
    $78cfea2b71520c0e$var$load("9L8th"),
    $78cfea2b71520c0e$var$load("kSCMk"),
    $78cfea2b71520c0e$var$load("daCl8"),
    $78cfea2b71520c0e$var$load("gQSWJ"),
    $78cfea2b71520c0e$var$load("9sZ57"),
    $78cfea2b71520c0e$var$load("a8f2N"),
    $78cfea2b71520c0e$var$load("bokK2"),
    $78cfea2b71520c0e$var$load("7VJdQ"),
    $78cfea2b71520c0e$var$load("7VwsU"),
    $78cfea2b71520c0e$var$load("fsZ6i"),
    $78cfea2b71520c0e$var$load("6nr9L"),
    $78cfea2b71520c0e$var$load("7ofLD"),
    $78cfea2b71520c0e$var$load("keSaw"),
    $78cfea2b71520c0e$var$load("9fG7I"),
    $78cfea2b71520c0e$var$load("gwAWX"),
    $78cfea2b71520c0e$var$load("h4Nf7"),
    $78cfea2b71520c0e$var$load("6ZgMI"),
    $78cfea2b71520c0e$var$load("9FBaW"),
    $78cfea2b71520c0e$var$load("6StWh"),
    $78cfea2b71520c0e$var$load("g9CVe"),
    $78cfea2b71520c0e$var$load("bMgpg"),
    $78cfea2b71520c0e$var$load("iBa9k"),
    $78cfea2b71520c0e$var$load("4aLlP"),
    $78cfea2b71520c0e$var$load("6gqpV"),
    $78cfea2b71520c0e$var$load("aZinD"),
    $78cfea2b71520c0e$var$load("4Pn6Z"),
    $78cfea2b71520c0e$var$load("6qah4"),
    $78cfea2b71520c0e$var$load("c6MKV"),
    $78cfea2b71520c0e$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("kKR9r", function(module, exports) {

let $f1c15548c1acea32$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $f1c15548c1acea32$var$load("7Q0UC"),
    $f1c15548c1acea32$var$load("hf7yW"),
    $f1c15548c1acea32$var$load("2HRN3"),
    $f1c15548c1acea32$var$load("hZSgn"),
    $f1c15548c1acea32$var$load("lnKog"),
    $f1c15548c1acea32$var$load("2aE9V"),
    $f1c15548c1acea32$var$load("iQ0Jm"),
    $f1c15548c1acea32$var$load("9L8th"),
    $f1c15548c1acea32$var$load("kSCMk"),
    $f1c15548c1acea32$var$load("daCl8"),
    $f1c15548c1acea32$var$load("gQSWJ"),
    $f1c15548c1acea32$var$load("9sZ57"),
    $f1c15548c1acea32$var$load("a8f2N"),
    $f1c15548c1acea32$var$load("bokK2"),
    $f1c15548c1acea32$var$load("7VJdQ"),
    $f1c15548c1acea32$var$load("7VwsU"),
    $f1c15548c1acea32$var$load("fsZ6i"),
    $f1c15548c1acea32$var$load("6nr9L"),
    $f1c15548c1acea32$var$load("7ofLD"),
    $f1c15548c1acea32$var$load("keSaw"),
    $f1c15548c1acea32$var$load("9fG7I"),
    $f1c15548c1acea32$var$load("gwAWX"),
    $f1c15548c1acea32$var$load("h4Nf7"),
    $f1c15548c1acea32$var$load("6ZgMI"),
    $f1c15548c1acea32$var$load("9FBaW"),
    $f1c15548c1acea32$var$load("6StWh"),
    $f1c15548c1acea32$var$load("g9CVe"),
    $f1c15548c1acea32$var$load("bMgpg"),
    $f1c15548c1acea32$var$load("iBa9k"),
    $f1c15548c1acea32$var$load("4aLlP"),
    $f1c15548c1acea32$var$load("6gqpV"),
    $f1c15548c1acea32$var$load("aZinD"),
    $f1c15548c1acea32$var$load("4Pn6Z"),
    $f1c15548c1acea32$var$load("6qah4"),
    $f1c15548c1acea32$var$load("c6MKV"),
    $f1c15548c1acea32$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("jPIxF", function(module, exports) {

let $e70554e1340fdc8c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $e70554e1340fdc8c$var$load("7Q0UC"),
    $e70554e1340fdc8c$var$load("hf7yW"),
    $e70554e1340fdc8c$var$load("2HRN3"),
    $e70554e1340fdc8c$var$load("hZSgn"),
    $e70554e1340fdc8c$var$load("lnKog"),
    $e70554e1340fdc8c$var$load("2aE9V"),
    $e70554e1340fdc8c$var$load("iQ0Jm"),
    $e70554e1340fdc8c$var$load("9L8th"),
    $e70554e1340fdc8c$var$load("kSCMk"),
    $e70554e1340fdc8c$var$load("daCl8"),
    $e70554e1340fdc8c$var$load("gQSWJ"),
    $e70554e1340fdc8c$var$load("9sZ57"),
    $e70554e1340fdc8c$var$load("a8f2N"),
    $e70554e1340fdc8c$var$load("bokK2"),
    $e70554e1340fdc8c$var$load("7VJdQ"),
    $e70554e1340fdc8c$var$load("7VwsU"),
    $e70554e1340fdc8c$var$load("fsZ6i"),
    $e70554e1340fdc8c$var$load("6nr9L"),
    $e70554e1340fdc8c$var$load("7ofLD"),
    $e70554e1340fdc8c$var$load("keSaw"),
    $e70554e1340fdc8c$var$load("9fG7I"),
    $e70554e1340fdc8c$var$load("gwAWX"),
    $e70554e1340fdc8c$var$load("h4Nf7"),
    $e70554e1340fdc8c$var$load("6ZgMI"),
    $e70554e1340fdc8c$var$load("9FBaW"),
    $e70554e1340fdc8c$var$load("6StWh"),
    $e70554e1340fdc8c$var$load("g9CVe"),
    $e70554e1340fdc8c$var$load("bMgpg"),
    $e70554e1340fdc8c$var$load("iBa9k"),
    $e70554e1340fdc8c$var$load("4aLlP"),
    $e70554e1340fdc8c$var$load("6gqpV"),
    $e70554e1340fdc8c$var$load("aZinD"),
    $e70554e1340fdc8c$var$load("4Pn6Z"),
    $e70554e1340fdc8c$var$load("6qah4"),
    $e70554e1340fdc8c$var$load("c6MKV"),
    $e70554e1340fdc8c$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("jnGIw", function(module, exports) {

let $e1c14d0205eccfa5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $e1c14d0205eccfa5$var$load("9L8th"),
    $e1c14d0205eccfa5$var$load("kSCMk"),
    $e1c14d0205eccfa5$var$load("bokK2"),
    $e1c14d0205eccfa5$var$load("7VJdQ"),
    $e1c14d0205eccfa5$var$load("7VwsU"),
    $e1c14d0205eccfa5$var$load("fsZ6i"),
    $e1c14d0205eccfa5$var$load("6nr9L"),
    $e1c14d0205eccfa5$var$load("7ofLD"),
    $e1c14d0205eccfa5$var$load("keSaw"),
    $e1c14d0205eccfa5$var$load("9fG7I"),
    $e1c14d0205eccfa5$var$load("gwAWX"),
    $e1c14d0205eccfa5$var$load("h4Nf7"),
    $e1c14d0205eccfa5$var$load("6ZgMI"),
    $e1c14d0205eccfa5$var$load("9FBaW"),
    $e1c14d0205eccfa5$var$load("6StWh"),
    $e1c14d0205eccfa5$var$load("g9CVe"),
    $e1c14d0205eccfa5$var$load("6qah4"),
    $e1c14d0205eccfa5$var$load("bMgpg"),
    $e1c14d0205eccfa5$var$load("iBa9k"),
    $e1c14d0205eccfa5$var$load("6gqpV"),
    $e1c14d0205eccfa5$var$load("aZinD"),
    $e1c14d0205eccfa5$var$load("4Pn6Z"),
    $e1c14d0205eccfa5$var$load("c6MKV"),
    $e1c14d0205eccfa5$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("i7DKB", function(module, exports) {

let $d317b7118f95601a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $d317b7118f95601a$var$load("9L8th"),
    $d317b7118f95601a$var$load("kSCMk"),
    $d317b7118f95601a$var$load("bokK2"),
    $d317b7118f95601a$var$load("7VJdQ"),
    $d317b7118f95601a$var$load("7VwsU"),
    $d317b7118f95601a$var$load("fsZ6i"),
    $d317b7118f95601a$var$load("6nr9L"),
    $d317b7118f95601a$var$load("7ofLD"),
    $d317b7118f95601a$var$load("keSaw"),
    $d317b7118f95601a$var$load("9fG7I"),
    $d317b7118f95601a$var$load("gwAWX"),
    $d317b7118f95601a$var$load("h4Nf7"),
    $d317b7118f95601a$var$load("6ZgMI"),
    $d317b7118f95601a$var$load("9FBaW"),
    $d317b7118f95601a$var$load("6StWh"),
    $d317b7118f95601a$var$load("g9CVe"),
    $d317b7118f95601a$var$load("6qah4"),
    $d317b7118f95601a$var$load("bMgpg"),
    $d317b7118f95601a$var$load("iBa9k"),
    $d317b7118f95601a$var$load("6gqpV"),
    $d317b7118f95601a$var$load("aZinD"),
    $d317b7118f95601a$var$load("4Pn6Z"),
    $d317b7118f95601a$var$load("c6MKV"),
    $d317b7118f95601a$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("3aUdO", function(module, exports) {

let $24fdeabbb22f4da8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $24fdeabbb22f4da8$var$load("2HRN3"),
    $24fdeabbb22f4da8$var$load("hZSgn"),
    $24fdeabbb22f4da8$var$load("lnKog"),
    $24fdeabbb22f4da8$var$load("9L8th"),
    $24fdeabbb22f4da8$var$load("kSCMk"),
    $24fdeabbb22f4da8$var$load("bokK2"),
    $24fdeabbb22f4da8$var$load("7VJdQ"),
    $24fdeabbb22f4da8$var$load("7VwsU"),
    $24fdeabbb22f4da8$var$load("fsZ6i"),
    $24fdeabbb22f4da8$var$load("6nr9L"),
    $24fdeabbb22f4da8$var$load("7ofLD"),
    $24fdeabbb22f4da8$var$load("keSaw"),
    $24fdeabbb22f4da8$var$load("9fG7I"),
    $24fdeabbb22f4da8$var$load("gwAWX"),
    $24fdeabbb22f4da8$var$load("h4Nf7"),
    $24fdeabbb22f4da8$var$load("6ZgMI"),
    $24fdeabbb22f4da8$var$load("9FBaW"),
    $24fdeabbb22f4da8$var$load("6StWh"),
    $24fdeabbb22f4da8$var$load("g9CVe"),
    $24fdeabbb22f4da8$var$load("6qah4"),
    $24fdeabbb22f4da8$var$load("bMgpg"),
    $24fdeabbb22f4da8$var$load("iBa9k"),
    $24fdeabbb22f4da8$var$load("6gqpV"),
    $24fdeabbb22f4da8$var$load("aZinD"),
    $24fdeabbb22f4da8$var$load("4Pn6Z"),
    $24fdeabbb22f4da8$var$load("c6MKV"),
    $24fdeabbb22f4da8$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("fkiDa", function(module, exports) {

let $b2872cf6de9ce9b5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $b2872cf6de9ce9b5$var$load("7Q0UC"),
    $b2872cf6de9ce9b5$var$load("2HRN3"),
    $b2872cf6de9ce9b5$var$load("hZSgn"),
    $b2872cf6de9ce9b5$var$load("lnKog"),
    $b2872cf6de9ce9b5$var$load("9L8th"),
    $b2872cf6de9ce9b5$var$load("kSCMk"),
    $b2872cf6de9ce9b5$var$load("9sZ57"),
    $b2872cf6de9ce9b5$var$load("a8f2N"),
    $b2872cf6de9ce9b5$var$load("bokK2"),
    $b2872cf6de9ce9b5$var$load("7VJdQ"),
    $b2872cf6de9ce9b5$var$load("7VwsU"),
    $b2872cf6de9ce9b5$var$load("fsZ6i"),
    $b2872cf6de9ce9b5$var$load("6nr9L"),
    $b2872cf6de9ce9b5$var$load("7ofLD"),
    $b2872cf6de9ce9b5$var$load("keSaw"),
    $b2872cf6de9ce9b5$var$load("9fG7I"),
    $b2872cf6de9ce9b5$var$load("gwAWX"),
    $b2872cf6de9ce9b5$var$load("h4Nf7"),
    $b2872cf6de9ce9b5$var$load("6ZgMI"),
    $b2872cf6de9ce9b5$var$load("dTsOE"),
    $b2872cf6de9ce9b5$var$load("9FBaW"),
    $b2872cf6de9ce9b5$var$load("6StWh"),
    $b2872cf6de9ce9b5$var$load("g9CVe"),
    $b2872cf6de9ce9b5$var$load("6qah4"),
    $b2872cf6de9ce9b5$var$load("bMgpg"),
    $b2872cf6de9ce9b5$var$load("iBa9k"),
    $b2872cf6de9ce9b5$var$load("4aLlP"),
    $b2872cf6de9ce9b5$var$load("6gqpV"),
    $b2872cf6de9ce9b5$var$load("aZinD"),
    $b2872cf6de9ce9b5$var$load("4Pn6Z"),
    $b2872cf6de9ce9b5$var$load("c6MKV"),
    $b2872cf6de9ce9b5$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("eOKNB", function(module, exports) {

let $ac9a098688afd24d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ac9a098688afd24d$var$load("7Q0UC"),
    $ac9a098688afd24d$var$load("2HRN3"),
    $ac9a098688afd24d$var$load("hZSgn"),
    $ac9a098688afd24d$var$load("lnKog"),
    $ac9a098688afd24d$var$load("9L8th"),
    $ac9a098688afd24d$var$load("kSCMk"),
    $ac9a098688afd24d$var$load("9sZ57"),
    $ac9a098688afd24d$var$load("a8f2N"),
    $ac9a098688afd24d$var$load("bokK2"),
    $ac9a098688afd24d$var$load("7VJdQ"),
    $ac9a098688afd24d$var$load("7VwsU"),
    $ac9a098688afd24d$var$load("fsZ6i"),
    $ac9a098688afd24d$var$load("6nr9L"),
    $ac9a098688afd24d$var$load("7ofLD"),
    $ac9a098688afd24d$var$load("keSaw"),
    $ac9a098688afd24d$var$load("9fG7I"),
    $ac9a098688afd24d$var$load("gwAWX"),
    $ac9a098688afd24d$var$load("h4Nf7"),
    $ac9a098688afd24d$var$load("6ZgMI"),
    $ac9a098688afd24d$var$load("dTsOE"),
    $ac9a098688afd24d$var$load("9FBaW"),
    $ac9a098688afd24d$var$load("6StWh"),
    $ac9a098688afd24d$var$load("g9CVe"),
    $ac9a098688afd24d$var$load("6qah4"),
    $ac9a098688afd24d$var$load("bMgpg"),
    $ac9a098688afd24d$var$load("iBa9k"),
    $ac9a098688afd24d$var$load("4aLlP"),
    $ac9a098688afd24d$var$load("6gqpV"),
    $ac9a098688afd24d$var$load("aZinD"),
    $ac9a098688afd24d$var$load("4Pn6Z"),
    $ac9a098688afd24d$var$load("c6MKV"),
    $ac9a098688afd24d$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("2Oy3K", function(module, exports) {

let $20caabc2b7b24d48$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $20caabc2b7b24d48$var$load("9L8th"),
    $20caabc2b7b24d48$var$load("kSCMk"),
    $20caabc2b7b24d48$var$load("bokK2"),
    $20caabc2b7b24d48$var$load("7VJdQ"),
    $20caabc2b7b24d48$var$load("7VwsU"),
    $20caabc2b7b24d48$var$load("fsZ6i"),
    $20caabc2b7b24d48$var$load("6nr9L"),
    $20caabc2b7b24d48$var$load("7ofLD"),
    $20caabc2b7b24d48$var$load("keSaw"),
    $20caabc2b7b24d48$var$load("9fG7I"),
    $20caabc2b7b24d48$var$load("gwAWX"),
    $20caabc2b7b24d48$var$load("h4Nf7"),
    $20caabc2b7b24d48$var$load("6ZgMI"),
    $20caabc2b7b24d48$var$load("9FBaW"),
    $20caabc2b7b24d48$var$load("6StWh"),
    $20caabc2b7b24d48$var$load("g9CVe"),
    $20caabc2b7b24d48$var$load("6qah4"),
    $20caabc2b7b24d48$var$load("bMgpg"),
    $20caabc2b7b24d48$var$load("iBa9k"),
    $20caabc2b7b24d48$var$load("6gqpV"),
    $20caabc2b7b24d48$var$load("aZinD"),
    $20caabc2b7b24d48$var$load("4Pn6Z"),
    $20caabc2b7b24d48$var$load("c6MKV"),
    $20caabc2b7b24d48$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("5Cn12", function(module, exports) {

let $41725acc3759ef71$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $41725acc3759ef71$var$load("2HRN3"),
    $41725acc3759ef71$var$load("hZSgn"),
    $41725acc3759ef71$var$load("lnKog"),
    $41725acc3759ef71$var$load("9L8th"),
    $41725acc3759ef71$var$load("kSCMk"),
    $41725acc3759ef71$var$load("bokK2"),
    $41725acc3759ef71$var$load("7VJdQ"),
    $41725acc3759ef71$var$load("7VwsU"),
    $41725acc3759ef71$var$load("fsZ6i"),
    $41725acc3759ef71$var$load("6nr9L"),
    $41725acc3759ef71$var$load("7ofLD"),
    $41725acc3759ef71$var$load("keSaw"),
    $41725acc3759ef71$var$load("9fG7I"),
    $41725acc3759ef71$var$load("gwAWX"),
    $41725acc3759ef71$var$load("h4Nf7"),
    $41725acc3759ef71$var$load("6ZgMI"),
    $41725acc3759ef71$var$load("9FBaW"),
    $41725acc3759ef71$var$load("6StWh"),
    $41725acc3759ef71$var$load("g9CVe"),
    $41725acc3759ef71$var$load("6qah4"),
    $41725acc3759ef71$var$load("bMgpg"),
    $41725acc3759ef71$var$load("iBa9k"),
    $41725acc3759ef71$var$load("6gqpV"),
    $41725acc3759ef71$var$load("aZinD"),
    $41725acc3759ef71$var$load("4Pn6Z"),
    $41725acc3759ef71$var$load("c6MKV"),
    $41725acc3759ef71$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("851Aj", function(module, exports) {

let $5e2005098271ff10$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $5e2005098271ff10$var$load("2HRN3"),
    $5e2005098271ff10$var$load("hZSgn"),
    $5e2005098271ff10$var$load("lnKog"),
    $5e2005098271ff10$var$load("9L8th"),
    $5e2005098271ff10$var$load("kSCMk"),
    $5e2005098271ff10$var$load("bokK2"),
    $5e2005098271ff10$var$load("7VJdQ"),
    $5e2005098271ff10$var$load("7VwsU"),
    $5e2005098271ff10$var$load("fsZ6i"),
    $5e2005098271ff10$var$load("6nr9L"),
    $5e2005098271ff10$var$load("7ofLD"),
    $5e2005098271ff10$var$load("keSaw"),
    $5e2005098271ff10$var$load("9fG7I"),
    $5e2005098271ff10$var$load("gwAWX"),
    $5e2005098271ff10$var$load("h4Nf7"),
    $5e2005098271ff10$var$load("6ZgMI"),
    $5e2005098271ff10$var$load("9FBaW"),
    $5e2005098271ff10$var$load("6StWh"),
    $5e2005098271ff10$var$load("g9CVe"),
    $5e2005098271ff10$var$load("6qah4"),
    $5e2005098271ff10$var$load("bMgpg"),
    $5e2005098271ff10$var$load("iBa9k"),
    $5e2005098271ff10$var$load("6gqpV"),
    $5e2005098271ff10$var$load("aZinD"),
    $5e2005098271ff10$var$load("4Pn6Z"),
    $5e2005098271ff10$var$load("c6MKV"),
    $5e2005098271ff10$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});


parcelRegister("8a9Dm", function(module, exports) {

$parcel$export(module.exports, "getAppId", () => $2cc1b73219e08564$export$fb2283f4a44fb53);
$parcel$export(module.exports, "getModuleKey", () => $2cc1b73219e08564$export$b17b21a48c0a3273);
$parcel$export(module.exports, "getCustomContentType", () => $2cc1b73219e08564$export$9eb690901638fb96);
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
const $2cc1b73219e08564$export$d3ac53161a36a310 = (forgeData)=>{
    const extensionContext = forgeData?.extensionContexts?.[0];
    if (!extensionContext) return [];
    if (extensionContext.hasOwnProperty('extensions')) return extensionContext.extensions;
    if (extensionContext.hasOwnProperty('extensionsByType')) return extensionContext.extensionsByType;
    return [];
};

});

parcelRegister("dizL5", function(module, exports) {

$parcel$export(module.exports, "lazyForgeUIExtensionsWithLoader", () => $55b20ed34f146485$export$350b371bfb7f5e95);
$parcel$export(module.exports, "LazyForgeUIExtensions", () => $55b20ed34f146485$export$4cbc6d03d50a8849);

var $jmjWc = parcelRequire("jmjWc");

const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("iK2nA"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);

});
parcelRegister("iK2nA", function(module, exports) {

let $da4e5e672ed3883a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $da4e5e672ed3883a$var$load("2HRN3"),
    $da4e5e672ed3883a$var$load("hZSgn"),
    $da4e5e672ed3883a$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});



parcelRegister("gU0tm", function(module, exports) {

$parcel$export(module.exports, "MainContentContainer", () => $370afc622ad38e0a$export$b5bdfcb4cafd161b);
$parcel$export(module.exports, "WebPanelWrapper", () => $370afc622ad38e0a$export$b84f0b2bc7887721);
$parcel$export(module.exports, "FixedWebPanelWrapper", () => $370afc622ad38e0a$export$4f2bba08a8d0c194);
$parcel$export(module.exports, "FixedWebPanelSpacer", () => $370afc622ad38e0a$export$f0626b55b8fc2197);
$parcel$export(module.exports, "FixedForgeBannerSpacer", () => $370afc622ad38e0a$export$2ac536f43b2b4617);
$parcel$export(module.exports, "ContentBodyWrapper", () => $370afc622ad38e0a$export$905efa1400f24d18);
$parcel$export(module.exports, "ContentBody", () => $370afc622ad38e0a$export$e7f760d742ca707f);
$parcel$export(module.exports, "ContentBodyWithContainerType", () => $370afc622ad38e0a$export$cc84a1cb61e1d196);
$parcel$export(module.exports, "GlobalImagePreviewStyling", () => $370afc622ad38e0a$export$33d0451cd012d019);

var $gwFzn = parcelRequire("gwFzn");

var $lhCUr = parcelRequire("lhCUr");

var $gwrgp = parcelRequire("gwrgp");
const $370afc622ad38e0a$export$b5bdfcb4cafd161b = (0, $gwrgp.default)("div", {
    target: "e6tglj30"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ isEnableRightSidebarEnabled: isEnableRightSidebarEnabled, disableMinWidth: disableMinWidth, isNav4Enabled: isNav4Enabled })=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: isEnableRightSidebarEnabled ? `calc(
    100vw - var(--leftPanelWidth, 0px) - var(--leftSidebarWidth, 0px) -
      var(--rightPanelWidth, 0px) - var(--rightSidebarWidth, 0px)
  - ${"var(--ds-space-025, 2px)"}) !important` : isNav4Enabled ? '100%' : `calc(100% - ${"var(--ds-space-025, 2px)"})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginLeft: isNav4Enabled ? "var(--ds-space-0, 0px)" : "var(--ds-space-025, 2px)",
        transition: 'width 300ms cubic-bezier(0.2, 0, 0, 1) 0s',
        flexFlow: 'row wrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minWidth: !isEnableRightSidebarEnabled && !disableMinWidth ? 700 : '',
        '@media print': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            width: '100% !important'
        }
    }));
$370afc622ad38e0a$export$b5bdfcb4cafd161b.displayName = 'MainContentContainer';
const $370afc622ad38e0a$export$b84f0b2bc7887721 = (0, $gwrgp.default)("div", {
    target: "e6tglj31"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        display: props?.showPanel ? 'block' : 'none'
    }));
const $370afc622ad38e0a$export$4f2bba08a8d0c194 = (0, $gwrgp.default)("div", {
    target: "e6tglj32"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        display: props?.showPanel ? 'block' : 'none',
        zIndex: 12,
        // needs to be above 10 so it covers floating sticky table rows
        width: '100%',
        position: 'fixed',
        backgroundColor: "var(--ds-surface, #FFFFFF)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: !props?.isNav4Enabled && props?.isFullWidth ? '0' : 'var(--leftSidebarWidth)',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        !props?.isNav4Enabled && props?.isFullWidth ? 'none' : 'calc( 100vw - var(--leftPanelWidth, 0px) - var(--leftSidebarWidth, 0px) - var(--rightPanelWidth, 0px) - var(--rightSidebarWidth, 0px) )'
    }));
const $370afc622ad38e0a$export$f0626b55b8fc2197 = (0, $gwrgp.default)("div", {
    target: "e6tglj33"
})(()=>({
        height: 'var(--atl-general-webpanel-height)'
    }));
const $370afc622ad38e0a$export$2ac536f43b2b4617 = (0, $gwrgp.default)("div", {
    target: "e6tglj34"
})(()=>({
        height: 'var(--forge-page-banner-height)'
    }));
const $370afc622ad38e0a$export$905efa1400f24d18 = (0, $gwrgp.default)("div", {
    target: "e6tglj35"
})({
    name: "17r9j9j",
    styles: "margin-top:0;box-sizing:border-box;clear:both;position:relative;width:100%;display:flex;flex:0 1 auto;min-height:unset;"
});
const $370afc622ad38e0a$var$contentBodyDefaults = ()=>({
        background: "var(--ds-surface, #FFFFFF)",
        boxSizing: 'border-box',
        verticalAlign: 'top',
        width: '100%',
        minHeight: 'initial'
    });
const $370afc622ad38e0a$export$e7f760d742ca707f = (0, $gwrgp.default)("div", {
    target: "e6tglj36"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$370afc622ad38e0a$var$contentBodyDefaults(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...props.topElementStyle,
        padding: 0,
        width: '100%'
    }));
const $370afc622ad38e0a$export$cc84a1cb61e1d196 = (0, $gwrgp.default)("div", {
    target: "e6tglj37"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$370afc622ad38e0a$var$contentBodyDefaults(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...props.topElementStyle,
        padding: 0,
        width: '100%',
        containerType: 'inline-size',
        containerName: 'content-body-container'
    }));
// TODO: remove this when confluence-previews no longer used
var $370afc622ad38e0a$var$_ref = {
    name: "5bwef6",
    styles: ".cp-container[role='dialog']{z-index:350;}"
};
const $370afc622ad38e0a$export$33d0451cd012d019 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lhCUr.Global), {
        // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
        styles: $370afc622ad38e0a$var$_ref
    });

});




//# sourceMappingURL=MainLayout.8953f974.js.map
